export const tweakcnThemeRegistry = {
  $schema: 'https://ui.shadcn.com/schema/registry.json',
  name: 'tweakcn-theme-registry',
  homepage: 'https://tweakcn.com',
  items: [
    {
      name: 'modern-minimal',
      type: 'registry:style',
      title: 'Modern Minimal',
      description: 'A theme based on the Modern Minimal color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Inter, sans-serif',
          'font-mono': 'JetBrains Mono, monospace',
          'font-serif': 'Source Serif 4, serif',
          radius: '0.375rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '0 0% 100%',
          foreground: '0 0% 15%',
          card: '0 0% 100%',
          'card-foreground': '0 0% 15%',
          popover: '0 0% 100%',
          'popover-foreground': '0 0% 15%',
          primary: '38 92% 50%',
          'primary-foreground': '0 0% 0%',
          secondary: '220 14% 96%',
          'secondary-foreground': '215 14% 34%',
          muted: '210 20% 98%',
          'muted-foreground': '220 9% 46%',
          accent: '48 100% 96%',
          'accent-foreground': '23 83% 31%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '220 13% 91%',
          input: '220 13% 91%',
          ring: '38 92% 50%',
          'chart-1': '38 92% 50%',
          'chart-2': '220 14% 96%',
          'chart-3': '48 100% 96%',
          'chart-4': '23 83% 31%',
          'chart-5': '215 14% 34%',
          radius: '0.375rem',
          sidebar: '220 14% 98%',
          'sidebar-foreground': '0 0% 15%',
          'sidebar-primary': '38 92% 50%',
          'sidebar-primary-foreground': '0 0% 0%',
          'sidebar-accent': '48 100% 96%',
          'sidebar-accent-foreground': '23 83% 31%',
          'sidebar-border': '220 13% 91%',
          'sidebar-ring': '38 92% 50%',
          'font-sans': 'Inter, sans-serif',
          'font-serif': 'Source Serif 4, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 1px 2px -2px hsl(0 0% 0% / 0.1)',
          'shadow-xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 1px 2px -2px hsl(0 0% 0% / 0.1)',
          'shadow-sm': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 1px 2px -2px hsl(0 0% 0% / 0.1)',
          shadow: '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 1px 2px -2px hsl(0 0% 0% / 0.1)',
          'shadow-md': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 2px 4px -2px hsl(0 0% 0% / 0.1)',
          'shadow-lg': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 4px 6px -2px hsl(0 0% 0% / 0.1)',
          'shadow-xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 8px 10px -2px hsl(0 0% 0% / 0.1)',
          'shadow-2xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 8px 10px -2px hsl(0 0% 0% / 0.1)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '0 0% 9%',
          foreground: '0 0% 90%',
          card: '0 0% 15%',
          'card-foreground': '0 0% 90%',
          popover: '0 0% 15%',
          'popover-foreground': '0 0% 90%',
          primary: '38 92% 50%',
          'primary-foreground': '0 0% 0%',
          secondary: '0 0% 15%',
          'secondary-foreground': '0 0% 90%',
          muted: '0 0% 15%',
          'muted-foreground': '0 0% 64%',
          accent: '23 83% 31%',
          'accent-foreground': '48 97% 77%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '0 0% 25%',
          input: '0 0% 25%',
          ring: '38 92% 50%',
          'chart-1': '43 96% 56%',
          'chart-2': '38 92% 50%',
          'chart-3': '48 100% 96%',
          'chart-4': '23 83% 31%',
          'chart-5': '215 14% 34%',
          radius: '0.375rem',
          sidebar: '0 0% 7%',
          'sidebar-foreground': '0 0% 90%',
          'sidebar-primary': '38 92% 50%',
          'sidebar-primary-foreground': '0 0% 0%',
          'sidebar-accent': '23 83% 31%',
          'sidebar-accent-foreground': '48 97% 77%',
          'sidebar-border': '0 0% 25%',
          'sidebar-ring': '38 92% 50%',
          'font-sans': 'Inter, sans-serif',
          'font-serif': 'Source Serif 4, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 1px 2px -2px hsl(0 0% 0% / 0.1)',
          'shadow-xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 1px 2px -2px hsl(0 0% 0% / 0.1)',
          'shadow-sm': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 1px 2px -2px hsl(0 0% 0% / 0.1)',
          shadow: '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 1px 2px -2px hsl(0 0% 0% / 0.1)',
          'shadow-md': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 2px 4px -2px hsl(0 0% 0% / 0.1)',
          'shadow-lg': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 4px 6px -2px hsl(0 0% 0% / 0.1)',
          'shadow-xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 8px 10px -2px hsl(0 0% 0% / 0.1)',
          'shadow-2xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.1), 0px 8px 10px -2px hsl(0 0% 0% / 0.1)',
        },
      },
    },
    {
      name: 'violet-bloom',
      type: 'registry:style',
      title: 'Violet Bloom',
      description: 'A theme based on the Violet Bloom color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Plus Jakarta Sans, sans-serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'font-serif': 'Lora, serif',
          radius: '1.4rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '180 0% 99%',
          foreground: '0 0% 0%',
          card: '180 0% 99%',
          'card-foreground': '0 0% 0%',
          popover: '0 0% 99%',
          'popover-foreground': '0 0% 0%',
          primary: '258 100% 60%',
          'primary-foreground': '0 0% 100%',
          secondary: '214 24% 94%',
          'secondary-foreground': '195 0% 3%',
          muted: '0 0% 96%',
          'muted-foreground': '300 0% 32%',
          accent: '221 100% 94%',
          'accent-foreground': '216 76% 49%',
          destructive: '358 75% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '240 17% 92%',
          input: '0 0% 92%',
          ring: '0 0% 0%',
          'chart-1': '148 53% 54%',
          'chart-2': '258 100% 60%',
          'chart-3': '25 98% 58%',
          'chart-4': '217 77% 55%',
          'chart-5': '60 0% 45%',
          radius: '1.4rem',
          sidebar: '210 43% 97%',
          'sidebar-foreground': '0 0% 0%',
          'sidebar-primary': '0 0% 0%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '0 0% 92%',
          'sidebar-accent-foreground': '0 0% 0%',
          'sidebar-border': '0 0% 92%',
          'sidebar-ring': '0 0% 0%',
          'font-sans': 'Plus Jakarta Sans, sans-serif',
          'font-serif': 'Lora, serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.16',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '2px',
          'letter-spacing': '-0.025em',
          spacing: '0.27rem',
          'shadow-2xs': '0px 2px 3px 0px hsl(0 0% 0% / 0.08)',
          'shadow-xs': '0px 2px 3px 0px hsl(0 0% 0% / 0.08)',
          'shadow-sm': '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 1px 2px -1px hsl(0 0% 0% / 0.16)',
          shadow: '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 1px 2px -1px hsl(0 0% 0% / 0.16)',
          'shadow-md': '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 2px 4px -1px hsl(0 0% 0% / 0.16)',
          'shadow-lg': '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 4px 6px -1px hsl(0 0% 0% / 0.16)',
          'shadow-xl': '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 8px 10px -1px hsl(0 0% 0% / 0.16)',
          'shadow-2xl': '0px 2px 3px 0px hsl(0 0% 0% / 0.40)',
          'tracking-normal': '-0.025em',
        },
        dark: {
          background: '225 7% 11%',
          foreground: '240 0% 94%',
          card: '228 7% 14%',
          'card-foreground': '240 0% 94%',
          popover: '228 7% 14%',
          'popover-foreground': '240 0% 94%',
          primary: '258 100% 68%',
          'primary-foreground': '0 0% 100%',
          secondary: '227 10% 18%',
          'secondary-foreground': '240 0% 94%',
          muted: '227 10% 18%',
          'muted-foreground': '0 0% 63%',
          accent: '217 33% 17%',
          'accent-foreground': '208 100% 74%',
          destructive: '0 91% 71%',
          'destructive-foreground': '0 0% 100%',
          border: '223 6% 21%',
          input: '223 6% 21%',
          ring: '258 100% 68%',
          'chart-1': '142 69% 58%',
          'chart-2': '258 100% 68%',
          'chart-3': '360 94% 82%',
          'chart-4': '218 88% 65%',
          'chart-5': '0 0% 63%',
          radius: '1.4rem',
          sidebar: '240 4% 9%',
          'sidebar-foreground': '240 0% 94%',
          'sidebar-primary': '258 100% 68%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '227 10% 18%',
          'sidebar-accent-foreground': '258 100% 68%',
          'sidebar-border': '223 6% 21%',
          'sidebar-ring': '258 100% 68%',
          'font-sans': 'Plus Jakarta Sans, sans-serif',
          'font-serif': 'Lora, serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.16',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '2px',
          'letter-spacing': '-0.025em',
          spacing: '0.27rem',
          'shadow-2xs': '0px 2px 3px 0px hsl(0 0% 0% / 0.08)',
          'shadow-xs': '0px 2px 3px 0px hsl(0 0% 0% / 0.08)',
          'shadow-sm': '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 1px 2px -1px hsl(0 0% 0% / 0.16)',
          shadow: '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 1px 2px -1px hsl(0 0% 0% / 0.16)',
          'shadow-md': '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 2px 4px -1px hsl(0 0% 0% / 0.16)',
          'shadow-lg': '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 4px 6px -1px hsl(0 0% 0% / 0.16)',
          'shadow-xl': '0px 2px 3px 0px hsl(0 0% 0% / 0.16), 0px 8px 10px -1px hsl(0 0% 0% / 0.16)',
          'shadow-2xl': '0px 2px 3px 0px hsl(0 0% 0% / 0.40)',
        },
      },
    },
    {
      name: 't3-chat',
      type: 'registry:style',
      title: 'T3 Chat',
      description: 'A theme based on the T3 Chat color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans':
            "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
          'font-mono':
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '300 33% 97%',
          foreground: '296 56% 21%',
          card: '300 33% 97%',
          'card-foreground': '296 56% 21%',
          popover: '0 0% 100%',
          'popover-foreground': '296 56% 21%',
          primary: '333 43% 46%',
          'primary-foreground': '0 0% 100%',
          secondary: '315 62% 86%',
          'secondary-foreground': '296 41% 35%',
          muted: '311 49% 93%',
          'muted-foreground': '296 33% 40%',
          accent: '315 62% 86%',
          'accent-foreground': '296 41% 35%',
          destructive: '358 44% 47%',
          'destructive-foreground': '0 0% 100%',
          border: '305 61% 84%',
          input: '317 44% 83%',
          ring: '333 71% 51%',
          'chart-1': '318 70% 50%',
          'chart-2': '272 82% 40%',
          'chart-3': '197 37% 24%',
          'chart-4': '43 74% 66%',
          'chart-5': '27 87% 67%',
          radius: '0.5rem',
          sidebar: '290 50% 93%',
          'sidebar-foreground': '327 77% 38%',
          'sidebar-primary': '240 10% 30%',
          'sidebar-primary-foreground': '320 47% 96%',
          'sidebar-accent': '60 7% 97%',
          'sidebar-accent-foreground': '240 10% 30%',
          'sidebar-border': '20 7% 92%',
          'sidebar-ring': '333 71% 51%',
          'font-sans':
            "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono':
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '270 15% 13%',
          foreground: '272 28% 82%',
          card: '270 14% 17%',
          'card-foreground': '325 23% 82%',
          popover: '320 23% 5%',
          'popover-foreground': '326 33% 96%',
          primary: '332 100% 32%',
          'primary-foreground': '329 59% 85%',
          secondary: '274 15% 21%',
          'secondary-foreground': '270 30% 83%',
          muted: '273 14% 15%',
          'muted-foreground': '269 21% 76%',
          accent: '272 20% 27%',
          'accent-foreground': '326 33% 96%',
          destructive: '351 50% 13%',
          'destructive-foreground': '0 0% 100%',
          border: '327 8% 21%',
          input: '312 9% 22%',
          ring: '333 71% 51%',
          'chart-1': '333 43% 46%',
          'chart-2': '273 55% 55%',
          'chart-3': '30 80% 55%',
          'chart-4': '280 65% 60%',
          'chart-5': '340 75% 55%',
          radius: '0.5rem',
          sidebar: '309 17% 8%',
          'sidebar-foreground': '327 26% 84%',
          'sidebar-primary': '224 76% 48%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '318 21% 12%',
          'sidebar-accent-foreground': '240 5% 96%',
          'sidebar-border': '0 0% 0%',
          'sidebar-ring': '333 71% 51%',
          'font-sans':
            "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono':
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'twitter',
      type: 'registry:style',
      title: 'Twitter',
      description: 'A theme based on the Twitter color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Open Sans, sans-serif',
          'font-mono': 'Menlo, monospace',
          'font-serif': 'Georgia, serif',
          radius: '1.3rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '0 0% 100%',
          foreground: '210 25% 8%',
          card: '180 7% 97%',
          'card-foreground': '210 25% 8%',
          popover: '0 0% 100%',
          'popover-foreground': '210 25% 8%',
          primary: '204 88% 53%',
          'primary-foreground': '0 0% 100%',
          secondary: '210 25% 8%',
          'secondary-foreground': '0 0% 100%',
          muted: '240 2% 90%',
          'muted-foreground': '210 25% 8%',
          accent: '212 51% 93%',
          'accent-foreground': '204 88% 53%',
          destructive: '356 91% 54%',
          'destructive-foreground': '0 0% 100%',
          border: '201 30% 91%',
          input: '200 23% 97%',
          ring: '203 89% 53%',
          'chart-1': '204 88% 53%',
          'chart-2': '160 100% 36%',
          'chart-3': '42 93% 56%',
          'chart-4': '147 79% 42%',
          'chart-5': '341 75% 51%',
          radius: '1.3rem',
          sidebar: '180 7% 97%',
          'sidebar-foreground': '210 25% 8%',
          'sidebar-primary': '204 88% 53%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '212 51% 93%',
          'sidebar-accent-foreground': '204 88% 53%',
          'sidebar-border': '205 25% 91%',
          'sidebar-ring': '203 89% 53%',
          'font-sans': 'Open Sans, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': 'Menlo, monospace',
          'shadow-color': 'rgba(29,161,242,0.15)',
          'shadow-opacity': '0',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'shadow-xs': '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'shadow-sm':
            '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 1px 2px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          shadow:
            '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 1px 2px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'shadow-md':
            '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 2px 4px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'shadow-lg':
            '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 4px 6px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'shadow-xl':
            '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 8px 10px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'shadow-2xl': '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '0 0% 0%',
          foreground: '200 7% 91%',
          card: '228 10% 10%',
          'card-foreground': '120 0% 85%',
          popover: '0 0% 0%',
          'popover-foreground': '200 7% 91%',
          primary: '204 88% 53%',
          'primary-foreground': '0 0% 100%',
          secondary: '195 15% 95%',
          'secondary-foreground': '210 25% 8%',
          muted: '120 0% 9%',
          'muted-foreground': '210 3% 46%',
          accent: '206 70% 8%',
          'accent-foreground': '204 88% 53%',
          destructive: '356 91% 54%',
          'destructive-foreground': '0 0% 100%',
          border: '210 5% 15%',
          input: '208 28% 18%',
          ring: '203 89% 53%',
          'chart-1': '204 88% 53%',
          'chart-2': '160 100% 36%',
          'chart-3': '42 93% 56%',
          'chart-4': '147 79% 42%',
          'chart-5': '341 75% 51%',
          radius: '1.3rem',
          sidebar: '228 10% 10%',
          'sidebar-foreground': '120 0% 85%',
          'sidebar-primary': '203 89% 53%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '206 70% 8%',
          'sidebar-accent-foreground': '204 88% 53%',
          'sidebar-border': '206 16% 26%',
          'sidebar-ring': '203 89% 53%',
          'font-sans': 'Open Sans, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': 'Menlo, monospace',
          'shadow-color': 'rgba(29,161,242,0.25)',
          'shadow-opacity': '0',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'shadow-xs': '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'shadow-sm':
            '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 1px 2px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          shadow:
            '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 1px 2px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'shadow-md':
            '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 2px 4px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'shadow-lg':
            '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 4px 6px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'shadow-xl':
            '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00), 0px 8px 10px -1px hsl(202.8169 89.1213% 53.1373% / 0.00)',
          'shadow-2xl': '0px 2px 0px 0px hsl(202.8169 89.1213% 53.1373% / 0.00)',
        },
      },
    },
    {
      name: 'mocha-mousse',
      type: 'registry:style',
      title: 'Mocha Mousse',
      description: 'A theme based on the Mocha Mousse color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'DM Sans, sans-serif',
          'font-mono': 'Menlo, monospace',
          'font-serif': 'Georgia, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '55 30% 92%',
          foreground: '16 15% 29%',
          card: '55 30% 92%',
          'card-foreground': '16 15% 29%',
          popover: '0 0% 100%',
          'popover-foreground': '16 15% 29%',
          primary: '18 25% 52%',
          'primary-foreground': '0 0% 100%',
          secondary: '37 22% 65%',
          'secondary-foreground': '0 0% 100%',
          muted: '20 45% 81%',
          'muted-foreground': '14 21% 45%',
          accent: '20 45% 81%',
          'accent-foreground': '16 15% 29%',
          destructive: '23 15% 11%',
          'destructive-foreground': '0 0% 100%',
          border: '37 22% 65%',
          input: '37 22% 65%',
          ring: '18 25% 52%',
          'chart-1': '18 25% 52%',
          'chart-2': '14 21% 45%',
          'chart-3': '22 33% 65%',
          'chart-4': '37 22% 65%',
          'chart-5': '22 19% 55%',
          radius: '0.5rem',
          sidebar: '21 44% 86%',
          'sidebar-foreground': '16 15% 29%',
          'sidebar-primary': '18 25% 52%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '22 33% 65%',
          'sidebar-accent-foreground': '0 0% 100%',
          'sidebar-border': '22 19% 55%',
          'sidebar-ring': '18 25% 52%',
          'font-sans': 'DM Sans, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': 'Menlo, monospace',
          'shadow-color': '20 18% 51% / 0.4',
          'shadow-opacity': '0.11',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '2px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '2px 2px 0px 0px hsl(20 18% 51% / 0.06)',
          'shadow-xs': '2px 2px 0px 0px hsl(20 18% 51% / 0.06)',
          'shadow-sm': '2px 2px 0px 0px hsl(20 18% 51% / 0.11), 2px 1px 2px -1px hsl(20 18% 51% / 0.11)',
          shadow: '2px 2px 0px 0px hsl(20 18% 51% / 0.11), 2px 1px 2px -1px hsl(20 18% 51% / 0.11)',
          'shadow-md': '2px 2px 0px 0px hsl(20 18% 51% / 0.11), 2px 2px 4px -1px hsl(20 18% 51% / 0.11)',
          'shadow-lg': '2px 2px 0px 0px hsl(20 18% 51% / 0.11), 2px 4px 6px -1px hsl(20 18% 51% / 0.11)',
          'shadow-xl': '2px 2px 0px 0px hsl(20 18% 51% / 0.11), 2px 8px 10px -1px hsl(20 18% 51% / 0.11)',
          'shadow-2xl': '2px 2px 0px 0px hsl(20 18% 51% / 0.28)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '20 15% 15%',
          foreground: '55 30% 92%',
          card: '21 13% 21%',
          'card-foreground': '55 30% 92%',
          popover: '21 13% 21%',
          'popover-foreground': '55 30% 92%',
          primary: '22 33% 65%',
          'primary-foreground': '20 15% 15%',
          secondary: '14 21% 45%',
          'secondary-foreground': '55 30% 92%',
          muted: '16 15% 29%',
          'muted-foreground': '21 27% 69%',
          accent: '37 22% 65%',
          'accent-foreground': '20 15% 15%',
          destructive: '360 69% 67%',
          'destructive-foreground': '20 15% 15%',
          border: '16 15% 29%',
          input: '16 15% 29%',
          ring: '22 33% 65%',
          'chart-1': '22 33% 65%',
          'chart-2': '37 22% 65%',
          'chart-3': '18 25% 52%',
          'chart-4': '14 21% 45%',
          'chart-5': '22 19% 55%',
          radius: '0.5rem',
          sidebar: '23 15% 11%',
          'sidebar-foreground': '55 30% 92%',
          'sidebar-primary': '22 33% 65%',
          'sidebar-primary-foreground': '23 15% 11%',
          'sidebar-accent': '37 22% 65%',
          'sidebar-accent-foreground': '23 15% 11%',
          'sidebar-border': '16 15% 29%',
          'sidebar-ring': '22 33% 65%',
          'font-sans': 'DM Sans, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': 'Menlo, monospace',
          'shadow-color': '20 18% 30% / 0.5',
          'shadow-opacity': '0.11',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '2px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '2px 2px 0px 0px hsl(20 18% 30% / 0.06)',
          'shadow-xs': '2px 2px 0px 0px hsl(20 18% 30% / 0.06)',
          'shadow-sm': '2px 2px 0px 0px hsl(20 18% 30% / 0.11), 2px 1px 2px -1px hsl(20 18% 30% / 0.11)',
          shadow: '2px 2px 0px 0px hsl(20 18% 30% / 0.11), 2px 1px 2px -1px hsl(20 18% 30% / 0.11)',
          'shadow-md': '2px 2px 0px 0px hsl(20 18% 30% / 0.11), 2px 2px 4px -1px hsl(20 18% 30% / 0.11)',
          'shadow-lg': '2px 2px 0px 0px hsl(20 18% 30% / 0.11), 2px 4px 6px -1px hsl(20 18% 30% / 0.11)',
          'shadow-xl': '2px 2px 0px 0px hsl(20 18% 30% / 0.11), 2px 8px 10px -1px hsl(20 18% 30% / 0.11)',
          'shadow-2xl': '2px 2px 0px 0px hsl(20 18% 30% / 0.28)',
        },
      },
    },
    {
      name: 'bubblegum',
      type: 'registry:style',
      title: 'Bubblegum',
      description: 'A theme based on the Bubblegum color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Poppins, sans-serif',
          'font-mono': 'Fira Code, monospace',
          'font-serif': 'Lora, serif',
          radius: '0.4rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '330 47% 93%',
          foreground: '90 0% 36%',
          card: '42 93% 89%',
          'card-foreground': '90 0% 36%',
          popover: '0 0% 100%',
          'popover-foreground': '90 0% 36%',
          primary: '326 58% 56%',
          'primary-foreground': '0 0% 100%',
          secondary: '182 44% 68%',
          'secondary-foreground': '0 0% 20%',
          muted: '191 59% 81%',
          'muted-foreground': '0 0% 48%',
          accent: '42 91% 82%',
          'accent-foreground': '0 0% 20%',
          destructive: '360 92% 71%',
          'destructive-foreground': '0 0% 100%',
          border: '326 58% 56%',
          input: '0 0% 89%',
          ring: '330 70% 67%',
          'chart-1': '330 70% 67%',
          'chart-2': '190 62% 70%',
          'chart-3': '42 91% 82%',
          'chart-4': '330 78% 79%',
          'chart-5': '331 64% 56%',
          radius: '0.4rem',
          sidebar: '326 70% 91%',
          'sidebar-foreground': '0 0% 20%',
          'sidebar-primary': '330 81% 60%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '327 87% 82%',
          'sidebar-accent-foreground': '0 0% 20%',
          'sidebar-border': '269 100% 95%',
          'sidebar-ring': '330 81% 60%',
          'font-sans': 'Poppins, sans-serif',
          'font-serif': 'Lora, serif',
          'font-mono': 'Fira Code, monospace',
          'shadow-color': '325.78 58.18% 56.86% / 0.5',
          'shadow-opacity': '1.0',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '3px',
          'shadow-offset-y': '3px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '3px 3px 0px 0px hsl(325.7800 58.1800% 56.8600% / 0.50)',
          'shadow-xs': '3px 3px 0px 0px hsl(325.7800 58.1800% 56.8600% / 0.50)',
          'shadow-sm':
            '3px 3px 0px 0px hsl(325.7800 58.1800% 56.8600% / 1.00), 3px 1px 2px -1px hsl(325.7800 58.1800% 56.8600% / 1.00)',
          shadow:
            '3px 3px 0px 0px hsl(325.7800 58.1800% 56.8600% / 1.00), 3px 1px 2px -1px hsl(325.7800 58.1800% 56.8600% / 1.00)',
          'shadow-md':
            '3px 3px 0px 0px hsl(325.7800 58.1800% 56.8600% / 1.00), 3px 2px 4px -1px hsl(325.7800 58.1800% 56.8600% / 1.00)',
          'shadow-lg':
            '3px 3px 0px 0px hsl(325.7800 58.1800% 56.8600% / 1.00), 3px 4px 6px -1px hsl(325.7800 58.1800% 56.8600% / 1.00)',
          'shadow-xl':
            '3px 3px 0px 0px hsl(325.7800 58.1800% 56.8600% / 1.00), 3px 8px 10px -1px hsl(325.7800 58.1800% 56.8600% / 1.00)',
          'shadow-2xl': '3px 3px 0px 0px hsl(325.7800 58.1800% 56.8600% / 2.50)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '201 44% 13%',
          foreground: '334 40% 92%',
          card: '201 33% 16%',
          'card-foreground': '334 40% 92%',
          popover: '201 33% 16%',
          'popover-foreground': '334 40% 92%',
          primary: '42 91% 82%',
          'primary-foreground': '201 44% 13%',
          secondary: '346 55% 76%',
          'secondary-foreground': '201 44% 13%',
          muted: '214 9% 15%',
          'muted-foreground': '346 55% 76%',
          accent: '338 40% 63%',
          'accent-foreground': '334 40% 92%',
          destructive: '328 70% 63%',
          'destructive-foreground': '201 44% 13%',
          border: '206 28% 27%',
          input: '201 31% 18%',
          ring: '184 41% 51%',
          'chart-1': '184 41% 51%',
          'chart-2': '346 55% 76%',
          'chart-3': '338 40% 63%',
          'chart-4': '191 65% 26%',
          'chart-5': '214 9% 15%',
          radius: '0.4rem',
          sidebar: '202 43% 11%',
          'sidebar-foreground': '220 14% 96%',
          'sidebar-primary': '330 81% 60%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '327 87% 82%',
          'sidebar-accent-foreground': '215 28% 17%',
          'sidebar-border': '217 19% 27%',
          'sidebar-ring': '330 81% 60%',
          'font-sans': 'Poppins, sans-serif',
          'font-serif': 'Lora, serif',
          'font-mono': 'Fira Code, monospace',
          'shadow-color': '206 28% 27%',
          'shadow-opacity': '1.0',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '3px',
          'shadow-offset-y': '3px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '3px 3px 0px 0px hsl(206.1538 28.0576% 27.2549% / 0.50)',
          'shadow-xs': '3px 3px 0px 0px hsl(206.1538 28.0576% 27.2549% / 0.50)',
          'shadow-sm':
            '3px 3px 0px 0px hsl(206.1538 28.0576% 27.2549% / 1.00), 3px 1px 2px -1px hsl(206.1538 28.0576% 27.2549% / 1.00)',
          shadow:
            '3px 3px 0px 0px hsl(206.1538 28.0576% 27.2549% / 1.00), 3px 1px 2px -1px hsl(206.1538 28.0576% 27.2549% / 1.00)',
          'shadow-md':
            '3px 3px 0px 0px hsl(206.1538 28.0576% 27.2549% / 1.00), 3px 2px 4px -1px hsl(206.1538 28.0576% 27.2549% / 1.00)',
          'shadow-lg':
            '3px 3px 0px 0px hsl(206.1538 28.0576% 27.2549% / 1.00), 3px 4px 6px -1px hsl(206.1538 28.0576% 27.2549% / 1.00)',
          'shadow-xl':
            '3px 3px 0px 0px hsl(206.1538 28.0576% 27.2549% / 1.00), 3px 8px 10px -1px hsl(206.1538 28.0576% 27.2549% / 1.00)',
          'shadow-2xl': '3px 3px 0px 0px hsl(206.1538 28.0576% 27.2549% / 2.50)',
        },
      },
    },
    {
      name: 'amethyst-haze',
      type: 'registry:style',
      title: 'Amethyst Haze',
      description: 'A theme based on the Amethyst Haze color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Geist, sans-serif',
          'font-mono': '"Fira Code", "Courier New", monospace',
          'font-serif': '"Lora", Georgia, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '260 23% 97%',
          foreground: '243 14% 27%',
          card: '0 0% 100%',
          'card-foreground': '243 14% 27%',
          popover: '0 0% 100%',
          'popover-foreground': '243 14% 27%',
          primary: '260 23% 57%',
          'primary-foreground': '260 23% 97%',
          secondary: '259 33% 89%',
          'secondary-foreground': '243 14% 27%',
          muted: '258 15% 87%',
          'muted-foreground': '248 10% 45%',
          accent: '342 57% 77%',
          'accent-foreground': '343 24% 24%',
          destructive: '0 62% 61%',
          'destructive-foreground': '260 23% 97%',
          border: '259 17% 82%',
          input: '260 23% 92%',
          ring: '260 23% 57%',
          'chart-1': '260 23% 57%',
          'chart-2': '342 57% 77%',
          'chart-3': '159 31% 59%',
          'chart-4': '36 77% 75%',
          'chart-5': '216 54% 76%',
          radius: '0.5rem',
          sidebar: '260 23% 95%',
          'sidebar-foreground': '243 14% 27%',
          'sidebar-primary': '260 23% 57%',
          'sidebar-primary-foreground': '260 23% 97%',
          'sidebar-accent': '342 57% 77%',
          'sidebar-accent-foreground': '343 24% 24%',
          'sidebar-border': '261 18% 85%',
          'sidebar-ring': '260 23% 57%',
          'font-sans': 'Geist, sans-serif',
          'font-serif': '"Lora", Georgia, serif',
          'font-mono': '"Fira Code", "Courier New", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.06',
          'shadow-blur': '5px',
          'shadow-spread': '1px',
          'shadow-offset-x': '1px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '1px 2px 5px 1px hsl(0 0% 0% / 0.03)',
          'shadow-xs': '1px 2px 5px 1px hsl(0 0% 0% / 0.03)',
          'shadow-sm': '1px 2px 5px 1px hsl(0 0% 0% / 0.06), 1px 1px 2px 0px hsl(0 0% 0% / 0.06)',
          shadow: '1px 2px 5px 1px hsl(0 0% 0% / 0.06), 1px 1px 2px 0px hsl(0 0% 0% / 0.06)',
          'shadow-md': '1px 2px 5px 1px hsl(0 0% 0% / 0.06), 1px 2px 4px 0px hsl(0 0% 0% / 0.06)',
          'shadow-lg': '1px 2px 5px 1px hsl(0 0% 0% / 0.06), 1px 4px 6px 0px hsl(0 0% 0% / 0.06)',
          'shadow-xl': '1px 2px 5px 1px hsl(0 0% 0% / 0.06), 1px 8px 10px 0px hsl(0 0% 0% / 0.06)',
          'shadow-2xl': '1px 2px 5px 1px hsl(0 0% 0% / 0.15)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '251 19% 12%',
          foreground: '250 36% 90%',
          card: '251 20% 16%',
          'card-foreground': '250 36% 90%',
          popover: '251 20% 16%',
          'popover-foreground': '250 36% 90%',
          primary: '263 33% 69%',
          'primary-foreground': '251 19% 12%',
          secondary: '254 15% 38%',
          'secondary-foreground': '250 36% 90%',
          muted: '254 21% 16%',
          'muted-foreground': '259 10% 64%',
          accent: '272 16% 21%',
          'accent-foreground': '346 69% 84%',
          destructive: '360 69% 67%',
          'destructive-foreground': '251 19% 12%',
          border: '252 19% 21%',
          input: '249 20% 19%',
          ring: '263 33% 69%',
          'chart-1': '263 33% 69%',
          'chart-2': '346 69% 84%',
          'chart-3': '159 31% 59%',
          'chart-4': '36 77% 75%',
          'chart-5': '216 54% 76%',
          radius: '0.5rem',
          sidebar: '252 20% 10%',
          'sidebar-foreground': '250 36% 90%',
          'sidebar-primary': '263 33% 69%',
          'sidebar-primary-foreground': '251 19% 12%',
          'sidebar-accent': '272 16% 21%',
          'sidebar-accent-foreground': '346 69% 84%',
          'sidebar-border': '249 20% 19%',
          'sidebar-ring': '263 33% 69%',
          'font-sans': 'Geist, sans-serif',
          'font-serif': '"Lora", Georgia, serif',
          'font-mono': '"Fira Code", "Courier New", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.06',
          'shadow-blur': '5px',
          'shadow-spread': '1px',
          'shadow-offset-x': '1px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '1px 2px 5px 1px hsl(0 0% 0% / 0.03)',
          'shadow-xs': '1px 2px 5px 1px hsl(0 0% 0% / 0.03)',
          'shadow-sm': '1px 2px 5px 1px hsl(0 0% 0% / 0.06), 1px 1px 2px 0px hsl(0 0% 0% / 0.06)',
          shadow: '1px 2px 5px 1px hsl(0 0% 0% / 0.06), 1px 1px 2px 0px hsl(0 0% 0% / 0.06)',
          'shadow-md': '1px 2px 5px 1px hsl(0 0% 0% / 0.06), 1px 2px 4px 0px hsl(0 0% 0% / 0.06)',
          'shadow-lg': '1px 2px 5px 1px hsl(0 0% 0% / 0.06), 1px 4px 6px 0px hsl(0 0% 0% / 0.06)',
          'shadow-xl': '1px 2px 5px 1px hsl(0 0% 0% / 0.06), 1px 8px 10px 0px hsl(0 0% 0% / 0.06)',
          'shadow-2xl': '1px 2px 5px 1px hsl(0 0% 0% / 0.15)',
        },
      },
    },
    {
      name: 'notebook',
      type: 'registry:style',
      title: 'Notebook',
      description: 'A theme based on the Notebook color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Architects Daughter, sans-serif',
          'font-mono': '"Fira Code", "Courier New", monospace',
          'font-serif': 'Georgia, serif',
          radius: '0.625rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '180 0% 98%',
          foreground: '180 0% 23%',
          card: '0 0% 100%',
          'card-foreground': '180 0% 23%',
          popover: '0 0% 100%',
          'popover-foreground': '180 0% 23%',
          primary: '0 0% 38%',
          'primary-foreground': '240 0% 94%',
          secondary: '0 0% 87%',
          'secondary-foreground': '180 0% 23%',
          muted: '60 0% 89%',
          'muted-foreground': '120 0% 31%',
          accent: '47 64% 87%',
          'accent-foreground': '14 26% 29%',
          destructive: '0 41% 63%',
          'destructive-foreground': '0 0% 100%',
          border: '360 1% 45%',
          input: '0 0% 100%',
          ring: '0 0% 63%',
          'chart-1': '0 0% 20%',
          'chart-2': '0 0% 33%',
          'chart-3': '0 0% 47%',
          'chart-4': '180 0% 60%',
          'chart-5': '0 0% 73%',
          radius: '0.625rem',
          sidebar: '240 0% 94%',
          'sidebar-foreground': '180 0% 23%',
          'sidebar-primary': '0 0% 38%',
          'sidebar-primary-foreground': '240 0% 94%',
          'sidebar-accent': '47 64% 87%',
          'sidebar-accent-foreground': '14 26% 29%',
          'sidebar-border': '180 0% 75%',
          'sidebar-ring': '0 0% 63%',
          'font-sans': 'Architects Daughter, sans-serif',
          'font-serif': '"Times New Roman", Times, serif',
          'font-mono': '"Courier New", Courier, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.03',
          'shadow-blur': '5px',
          'shadow-spread': '0px',
          'shadow-offset-x': '1px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0.5px',
          spacing: '0.25rem',
          'shadow-2xs': '1px 4px 5px 0px hsl(0 0% 0% / 0.01)',
          'shadow-xs': '1px 4px 5px 0px hsl(0 0% 0% / 0.01)',
          'shadow-sm': '1px 4px 5px 0px hsl(0 0% 0% / 0.03), 1px 1px 2px -1px hsl(0 0% 0% / 0.03)',
          shadow: '1px 4px 5px 0px hsl(0 0% 0% / 0.03), 1px 1px 2px -1px hsl(0 0% 0% / 0.03)',
          'shadow-md': '1px 4px 5px 0px hsl(0 0% 0% / 0.03), 1px 2px 4px -1px hsl(0 0% 0% / 0.03)',
          'shadow-lg': '1px 4px 5px 0px hsl(0 0% 0% / 0.03), 1px 4px 6px -1px hsl(0 0% 0% / 0.03)',
          'shadow-xl': '1px 4px 5px 0px hsl(0 0% 0% / 0.03), 1px 8px 10px -1px hsl(0 0% 0% / 0.03)',
          'shadow-2xl': '1px 4px 5px 0px hsl(0 0% 0% / 0.07)',
          'tracking-normal': '0.5px',
        },
        dark: {
          background: '300 0% 17%',
          foreground: '0 0% 86%',
          card: '0 0% 20%',
          'card-foreground': '0 0% 86%',
          popover: '0 0% 20%',
          'popover-foreground': '0 0% 86%',
          primary: '180 0% 69%',
          'primary-foreground': '300 0% 17%',
          secondary: '0 0% 35%',
          'secondary-foreground': '180 0% 75%',
          muted: '60 0% 27%',
          'muted-foreground': '0 0% 63%',
          accent: '120 0% 88%',
          'accent-foreground': '0 0% 20%',
          destructive: '360 36% 77%',
          'destructive-foreground': '300 0% 17%',
          border: '180 0% 31%',
          input: '0 0% 20%',
          ring: '180 0% 75%',
          'chart-1': '240 0% 94%',
          'chart-2': '140 0% 82%',
          'chart-3': '180 0% 69%',
          'chart-4': '180 0% 56%',
          'chart-5': '180 0% 44%',
          radius: '0.625rem',
          sidebar: '60 0% 13%',
          'sidebar-foreground': '0 0% 86%',
          'sidebar-primary': '180 0% 69%',
          'sidebar-primary-foreground': '60 0% 13%',
          'sidebar-accent': '120 0% 88%',
          'sidebar-accent-foreground': '0 0% 20%',
          'sidebar-border': '180 0% 31%',
          'sidebar-ring': '180 0% 75%',
          'font-sans': 'Architects Daughter, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': '"Fira Code", "Courier New", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.03',
          'shadow-blur': '5px',
          'shadow-spread': '0px',
          'shadow-offset-x': '1px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0.5px',
          spacing: '0.25rem',
          'shadow-2xs': '1px 4px 5px 0px hsl(0 0% 0% / 0.01)',
          'shadow-xs': '1px 4px 5px 0px hsl(0 0% 0% / 0.01)',
          'shadow-sm': '1px 4px 5px 0px hsl(0 0% 0% / 0.03), 1px 1px 2px -1px hsl(0 0% 0% / 0.03)',
          shadow: '1px 4px 5px 0px hsl(0 0% 0% / 0.03), 1px 1px 2px -1px hsl(0 0% 0% / 0.03)',
          'shadow-md': '1px 4px 5px 0px hsl(0 0% 0% / 0.03), 1px 2px 4px -1px hsl(0 0% 0% / 0.03)',
          'shadow-lg': '1px 4px 5px 0px hsl(0 0% 0% / 0.03), 1px 4px 6px -1px hsl(0 0% 0% / 0.03)',
          'shadow-xl': '1px 4px 5px 0px hsl(0 0% 0% / 0.03), 1px 8px 10px -1px hsl(0 0% 0% / 0.03)',
          'shadow-2xl': '1px 4px 5px 0px hsl(0 0% 0% / 0.07)',
        },
      },
    },
    {
      name: 'doom-64',
      type: 'registry:style',
      title: 'Doom 64',
      description: 'A theme based on the Doom 64 color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': '"Oxanium", sans-serif',
          'font-mono': '"Source Code Pro", monospace',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          radius: '0px',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '180 0% 80%',
          foreground: '0 0% 12%',
          card: '180 0% 69%',
          'card-foreground': '0 0% 12%',
          popover: '180 0% 69%',
          'popover-foreground': '0 0% 12%',
          primary: '360 73% 41%',
          'primary-foreground': '0 0% 100%',
          secondary: '82 39% 30%',
          'secondary-foreground': '0 0% 100%',
          muted: '120 0% 72%',
          'muted-foreground': '180 0% 29%',
          accent: '207 44% 49%',
          'accent-foreground': '0 0% 100%',
          destructive: '26 100% 50%',
          'destructive-foreground': '0 0% 0%',
          border: '120 0% 31%',
          input: '120 0% 31%',
          ring: '360 73% 41%',
          'chart-1': '360 73% 41%',
          'chart-2': '82 39% 30%',
          'chart-3': '207 44% 49%',
          'chart-4': '26 100% 50%',
          'chart-5': '16 18% 47%',
          radius: '0px',
          sidebar: '180 0% 69%',
          'sidebar-foreground': '0 0% 12%',
          'sidebar-primary': '360 73% 41%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '207 44% 49%',
          'sidebar-accent-foreground': '0 0% 100%',
          'sidebar-border': '120 0% 31%',
          'sidebar-ring': '360 73% 41%',
          'font-sans': '"Oxanium", sans-serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono': '"Source Code Pro", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.4',
          'shadow-blur': '4px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 2px 4px 0px hsl(0 0% 0% / 0.20)',
          'shadow-xs': '0px 2px 4px 0px hsl(0 0% 0% / 0.20)',
          'shadow-sm': '0px 2px 4px 0px hsl(0 0% 0% / 0.40), 0px 1px 2px -1px hsl(0 0% 0% / 0.40)',
          shadow: '0px 2px 4px 0px hsl(0 0% 0% / 0.40), 0px 1px 2px -1px hsl(0 0% 0% / 0.40)',
          'shadow-md': '0px 2px 4px 0px hsl(0 0% 0% / 0.40), 0px 2px 4px -1px hsl(0 0% 0% / 0.40)',
          'shadow-lg': '0px 2px 4px 0px hsl(0 0% 0% / 0.40), 0px 4px 6px -1px hsl(0 0% 0% / 0.40)',
          'shadow-xl': '0px 2px 4px 0px hsl(0 0% 0% / 0.40), 0px 8px 10px -1px hsl(0 0% 0% / 0.40)',
          'shadow-2xl': '0px 2px 4px 0px hsl(0 0% 0% / 1.00)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '150 0% 10%',
          foreground: '120 0% 88%',
          card: '180 0% 16%',
          'card-foreground': '120 0% 88%',
          popover: '180 0% 16%',
          'popover-foreground': '120 0% 88%',
          primary: '1 77% 55%',
          'primary-foreground': '0 0% 100%',
          secondary: '92 48% 42%',
          'secondary-foreground': '0 0% 0%',
          muted: '180 0% 15%',
          'muted-foreground': '0 0% 63%',
          accent: '207 89% 68%',
          'accent-foreground': '0 0% 0%',
          destructive: '38 100% 50%',
          'destructive-foreground': '0 0% 0%',
          border: '180 0% 29%',
          input: '180 0% 29%',
          ring: '1 77% 55%',
          'chart-1': '1 77% 55%',
          'chart-2': '92 48% 42%',
          'chart-3': '207 89% 68%',
          'chart-4': '38 100% 50%',
          'chart-5': '16 15% 56%',
          radius: '0px',
          sidebar: '0 0% 8%',
          'sidebar-foreground': '120 0% 88%',
          'sidebar-primary': '1 77% 55%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '207 89% 68%',
          'sidebar-accent-foreground': '0 0% 0%',
          'sidebar-border': '180 0% 29%',
          'sidebar-ring': '1 77% 55%',
          'font-sans': '"Oxanium", sans-serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono': '"Source Code Pro", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.6',
          'shadow-blur': '5px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 2px 5px 0px hsl(0 0% 0% / 0.30)',
          'shadow-xs': '0px 2px 5px 0px hsl(0 0% 0% / 0.30)',
          'shadow-sm': '0px 2px 5px 0px hsl(0 0% 0% / 0.60), 0px 1px 2px -1px hsl(0 0% 0% / 0.60)',
          shadow: '0px 2px 5px 0px hsl(0 0% 0% / 0.60), 0px 1px 2px -1px hsl(0 0% 0% / 0.60)',
          'shadow-md': '0px 2px 5px 0px hsl(0 0% 0% / 0.60), 0px 2px 4px -1px hsl(0 0% 0% / 0.60)',
          'shadow-lg': '0px 2px 5px 0px hsl(0 0% 0% / 0.60), 0px 4px 6px -1px hsl(0 0% 0% / 0.60)',
          'shadow-xl': '0px 2px 5px 0px hsl(0 0% 0% / 0.60), 0px 8px 10px -1px hsl(0 0% 0% / 0.60)',
          'shadow-2xl': '0px 2px 5px 0px hsl(0 0% 0% / 1.50)',
        },
      },
    },
    {
      name: 'catppuccin',
      type: 'registry:style',
      title: 'Catppuccin',
      description: 'A theme based on the Catppuccin color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Montserrat, sans-serif',
          'font-mono': 'Fira Code, monospace',
          'font-serif': 'Georgia, serif',
          radius: '0.35rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '220 23% 95%',
          foreground: '234 16% 35%',
          card: '0 0% 100%',
          'card-foreground': '234 16% 35%',
          popover: '223 16% 83%',
          'popover-foreground': '234 16% 35%',
          primary: '266 85% 58%',
          'primary-foreground': '0 0% 100%',
          secondary: '223 16% 83%',
          'secondary-foreground': '234 16% 35%',
          muted: '220 21% 89%',
          'muted-foreground': '233 10% 47%',
          accent: '197 96% 46%',
          'accent-foreground': '0 0% 100%',
          destructive: '347 87% 44%',
          'destructive-foreground': '0 0% 100%',
          border: '225 14% 77%',
          input: '223 16% 83%',
          ring: '266 85% 58%',
          'chart-1': '266 85% 58%',
          'chart-2': '197 96% 46%',
          'chart-3': '109 58% 40%',
          'chart-4': '22 99% 52%',
          'chart-5': '11 59% 67%',
          radius: '0.35rem',
          sidebar: '220 22% 92%',
          'sidebar-foreground': '234 16% 35%',
          'sidebar-primary': '266 85% 58%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '197 96% 46%',
          'sidebar-accent-foreground': '0 0% 100%',
          'sidebar-border': '225 14% 77%',
          'sidebar-ring': '266 85% 58%',
          'font-sans': 'Montserrat, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': 'Fira Code, monospace',
          'shadow-color': '240 30% 25%',
          'shadow-opacity': '0.12',
          'shadow-blur': '6px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 6px 0px hsl(240 30% 25% / 0.06)',
          'shadow-xs': '0px 4px 6px 0px hsl(240 30% 25% / 0.06)',
          'shadow-sm': '0px 4px 6px 0px hsl(240 30% 25% / 0.12), 0px 1px 2px -1px hsl(240 30% 25% / 0.12)',
          shadow: '0px 4px 6px 0px hsl(240 30% 25% / 0.12), 0px 1px 2px -1px hsl(240 30% 25% / 0.12)',
          'shadow-md': '0px 4px 6px 0px hsl(240 30% 25% / 0.12), 0px 2px 4px -1px hsl(240 30% 25% / 0.12)',
          'shadow-lg': '0px 4px 6px 0px hsl(240 30% 25% / 0.12), 0px 4px 6px -1px hsl(240 30% 25% / 0.12)',
          'shadow-xl': '0px 4px 6px 0px hsl(240 30% 25% / 0.12), 0px 8px 10px -1px hsl(240 30% 25% / 0.12)',
          'shadow-2xl': '0px 4px 6px 0px hsl(240 30% 25% / 0.30)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '240 21% 12%',
          foreground: '226 64% 88%',
          card: '240 21% 15%',
          'card-foreground': '226 64% 88%',
          popover: '234 13% 31%',
          'popover-foreground': '226 64% 88%',
          primary: '267 84% 81%',
          'primary-foreground': '240 21% 15%',
          secondary: '233 12% 39%',
          'secondary-foreground': '226 64% 88%',
          muted: '231 19% 20%',
          'muted-foreground': '228 24% 72%',
          accent: '189 71% 73%',
          'accent-foreground': '240 21% 15%',
          destructive: '343 81% 75%',
          'destructive-foreground': '240 21% 15%',
          border: '237 16% 23%',
          input: '237 16% 23%',
          ring: '267 84% 81%',
          'chart-1': '267 84% 81%',
          'chart-2': '189 71% 73%',
          'chart-3': '115 54% 76%',
          'chart-4': '23 92% 75%',
          'chart-5': '10 55% 91%',
          radius: '0.35rem',
          sidebar: '240 23% 9%',
          'sidebar-foreground': '226 64% 88%',
          'sidebar-primary': '267 84% 81%',
          'sidebar-primary-foreground': '240 21% 15%',
          'sidebar-accent': '189 71% 73%',
          'sidebar-accent-foreground': '240 21% 15%',
          'sidebar-border': '234 13% 31%',
          'sidebar-ring': '267 84% 81%',
          'font-sans': 'Montserrat, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': 'Fira Code, monospace',
          'shadow-color': '240 30% 25%',
          'shadow-opacity': '0.12',
          'shadow-blur': '6px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 6px 0px hsl(240 30% 25% / 0.06)',
          'shadow-xs': '0px 4px 6px 0px hsl(240 30% 25% / 0.06)',
          'shadow-sm': '0px 4px 6px 0px hsl(240 30% 25% / 0.12), 0px 1px 2px -1px hsl(240 30% 25% / 0.12)',
          shadow: '0px 4px 6px 0px hsl(240 30% 25% / 0.12), 0px 1px 2px -1px hsl(240 30% 25% / 0.12)',
          'shadow-md': '0px 4px 6px 0px hsl(240 30% 25% / 0.12), 0px 2px 4px -1px hsl(240 30% 25% / 0.12)',
          'shadow-lg': '0px 4px 6px 0px hsl(240 30% 25% / 0.12), 0px 4px 6px -1px hsl(240 30% 25% / 0.12)',
          'shadow-xl': '0px 4px 6px 0px hsl(240 30% 25% / 0.12), 0px 8px 10px -1px hsl(240 30% 25% / 0.12)',
          'shadow-2xl': '0px 4px 6px 0px hsl(240 30% 25% / 0.30)',
        },
      },
    },
    {
      name: 'graphite',
      type: 'registry:style',
      title: 'Graphite',
      description: 'A theme based on the Graphite color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Inter, sans-serif',
          'font-mono': 'Fira Code, monospace',
          'font-serif': 'Georgia, serif',
          radius: '0.35rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '240 0% 94%',
          foreground: '0 0% 20%',
          card: '0 0% 96%',
          'card-foreground': '0 0% 20%',
          popover: '0 0% 96%',
          'popover-foreground': '0 0% 20%',
          primary: '0 0% 38%',
          'primary-foreground': '0 0% 100%',
          secondary: '120 0% 88%',
          'secondary-foreground': '0 0% 20%',
          muted: '120 0% 85%',
          'muted-foreground': '300 0% 40%',
          accent: '180 0% 75%',
          'accent-foreground': '0 0% 20%',
          destructive: '360 60% 50%',
          'destructive-foreground': '0 0% 100%',
          border: '140 0% 82%',
          input: '120 0% 88%',
          ring: '0 0% 38%',
          'chart-1': '0 0% 38%',
          'chart-2': '180 18% 34%',
          'chart-3': '180 0% 56%',
          'chart-4': '0 0% 66%',
          'chart-5': '180 0% 75%',
          radius: '0.35rem',
          sidebar: '120 0% 92%',
          'sidebar-foreground': '0 0% 20%',
          'sidebar-primary': '0 0% 38%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '180 0% 75%',
          'sidebar-accent-foreground': '0 0% 20%',
          'sidebar-border': '140 0% 82%',
          'sidebar-ring': '0 0% 38%',
          'font-sans': 'Montserrat, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': 'Fira Code, monospace',
          'shadow-color': '0 0% 20% / 0.1',
          'shadow-opacity': '0.15',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 2px 0px 0px hsl(0 0% 20% / 0.07)',
          'shadow-xs': '0px 2px 0px 0px hsl(0 0% 20% / 0.07)',
          'shadow-sm': '0px 2px 0px 0px hsl(0 0% 20% / 0.15), 0px 1px 2px -1px hsl(0 0% 20% / 0.15)',
          shadow: '0px 2px 0px 0px hsl(0 0% 20% / 0.15), 0px 1px 2px -1px hsl(0 0% 20% / 0.15)',
          'shadow-md': '0px 2px 0px 0px hsl(0 0% 20% / 0.15), 0px 2px 4px -1px hsl(0 0% 20% / 0.15)',
          'shadow-lg': '0px 2px 0px 0px hsl(0 0% 20% / 0.15), 0px 4px 6px -1px hsl(0 0% 20% / 0.15)',
          'shadow-xl': '0px 2px 0px 0px hsl(0 0% 20% / 0.15), 0px 8px 10px -1px hsl(0 0% 20% / 0.15)',
          'shadow-2xl': '0px 2px 0px 0px hsl(0 0% 20% / 0.38)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '150 0% 10%',
          foreground: '120 0% 85%',
          card: '0 0% 13%',
          'card-foreground': '120 0% 85%',
          popover: '0 0% 13%',
          'popover-foreground': '120 0% 85%',
          primary: '0 0% 63%',
          'primary-foreground': '150 0% 10%',
          secondary: '0 0% 19%',
          'secondary-foreground': '120 0% 85%',
          muted: '180 0% 16%',
          'muted-foreground': '0 0% 50%',
          accent: '0 0% 25%',
          'accent-foreground': '120 0% 85%',
          destructive: '0 66% 64%',
          'destructive-foreground': '0 0% 100%',
          border: '0 0% 21%',
          input: '0 0% 19%',
          ring: '0 0% 63%',
          'chart-1': '0 0% 63%',
          'chart-2': '187 15% 56%',
          'chart-3': '180 0% 44%',
          'chart-4': '135 0% 35%',
          'chart-5': '0 0% 25%',
          radius: '0.35rem',
          sidebar: '0 0% 12%',
          'sidebar-foreground': '120 0% 85%',
          'sidebar-primary': '0 0% 63%',
          'sidebar-primary-foreground': '150 0% 10%',
          'sidebar-accent': '0 0% 25%',
          'sidebar-accent-foreground': '120 0% 85%',
          'sidebar-border': '0 0% 21%',
          'sidebar-ring': '0 0% 63%',
          'font-sans': 'Inter, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': 'Fira Code, monospace',
          'shadow-color': '0 0% 20% / 0.1',
          'shadow-opacity': '0.15',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 2px 0px 0px hsl(0 0% 20% / 0.07)',
          'shadow-xs': '0px 2px 0px 0px hsl(0 0% 20% / 0.07)',
          'shadow-sm': '0px 2px 0px 0px hsl(0 0% 20% / 0.15), 0px 1px 2px -1px hsl(0 0% 20% / 0.15)',
          shadow: '0px 2px 0px 0px hsl(0 0% 20% / 0.15), 0px 1px 2px -1px hsl(0 0% 20% / 0.15)',
          'shadow-md': '0px 2px 0px 0px hsl(0 0% 20% / 0.15), 0px 2px 4px -1px hsl(0 0% 20% / 0.15)',
          'shadow-lg': '0px 2px 0px 0px hsl(0 0% 20% / 0.15), 0px 4px 6px -1px hsl(0 0% 20% / 0.15)',
          'shadow-xl': '0px 2px 0px 0px hsl(0 0% 20% / 0.15), 0px 8px 10px -1px hsl(0 0% 20% / 0.15)',
          'shadow-2xl': '0px 2px 0px 0px hsl(0 0% 20% / 0.38)',
        },
      },
    },
    {
      name: 'perpetuity',
      type: 'registry:style',
      title: 'Perpetuity',
      description: 'A theme based on the Perpetuity color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Source Code Pro, monospace',
          'font-mono': 'Source Code Pro, monospace',
          'font-serif': 'Source Code Pro, monospace',
          radius: '0.125rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '180 21% 93%',
          foreground: '189 79% 19%',
          card: '180 24% 96%',
          'card-foreground': '189 79% 19%',
          popover: '180 24% 96%',
          'popover-foreground': '189 79% 19%',
          primary: '184 92% 29%',
          'primary-foreground': '0 0% 100%',
          secondary: '180 29% 88%',
          'secondary-foreground': '189 79% 19%',
          muted: '180 19% 90%',
          'muted-foreground': '184 31% 38%',
          accent: '184 39% 85%',
          'accent-foreground': '189 79% 19%',
          destructive: '0 62% 52%',
          'destructive-foreground': '0 0% 100%',
          border: '186 27% 85%',
          input: '180 29% 88%',
          ring: '184 92% 29%',
          'chart-1': '184 92% 29%',
          'chart-2': '184 69% 38%',
          'chart-3': '184 55% 48%',
          'chart-4': '184 54% 59%',
          'chart-5': '184 55% 70%',
          radius: '0.125rem',
          sidebar: '186 35% 89%',
          'sidebar-foreground': '189 79% 19%',
          'sidebar-primary': '184 92% 29%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '184 39% 85%',
          'sidebar-accent-foreground': '189 79% 19%',
          'sidebar-border': '186 27% 85%',
          'sidebar-ring': '184 92% 29%',
          'font-sans': 'Courier New, monospace',
          'font-serif': 'Courier New, monospace',
          'font-mono': 'Courier New, monospace',
          'shadow-color': '185 70% 30% / 0.15',
          'shadow-opacity': '0.15',
          'shadow-blur': '2px',
          'shadow-spread': '0px',
          'shadow-offset-x': '1px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '1px 1px 2px 0px hsl(185 70% 30% / 0.07)',
          'shadow-xs': '1px 1px 2px 0px hsl(185 70% 30% / 0.07)',
          'shadow-sm': '1px 1px 2px 0px hsl(185 70% 30% / 0.15), 1px 1px 2px -1px hsl(185 70% 30% / 0.15)',
          shadow: '1px 1px 2px 0px hsl(185 70% 30% / 0.15), 1px 1px 2px -1px hsl(185 70% 30% / 0.15)',
          'shadow-md': '1px 1px 2px 0px hsl(185 70% 30% / 0.15), 1px 2px 4px -1px hsl(185 70% 30% / 0.15)',
          'shadow-lg': '1px 1px 2px 0px hsl(185 70% 30% / 0.15), 1px 4px 6px -1px hsl(185 70% 30% / 0.15)',
          'shadow-xl': '1px 1px 2px 0px hsl(185 70% 30% / 0.15), 1px 8px 10px -1px hsl(185 70% 30% / 0.15)',
          'shadow-2xl': '1px 1px 2px 0px hsl(185 70% 30% / 0.38)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '196 52% 8%',
          foreground: '180 77% 61%',
          card: '192 51% 10%',
          'card-foreground': '180 77% 61%',
          popover: '192 51% 10%',
          'popover-foreground': '180 77% 61%',
          primary: '180 77% 61%',
          'primary-foreground': '196 52% 8%',
          secondary: '191 59% 21%',
          'secondary-foreground': '180 77% 61%',
          muted: '193 58% 14%',
          'muted-foreground': '180 51% 43%',
          accent: '191 59% 21%',
          'accent-foreground': '180 77% 61%',
          destructive: '0 79% 57%',
          'destructive-foreground': '180 0% 95%',
          border: '191 59% 21%',
          input: '191 59% 21%',
          ring: '180 77% 61%',
          'chart-1': '180 77% 61%',
          'chart-2': '180 51% 43%',
          'chart-3': '180 51% 36%',
          'chart-4': '184 58% 23%',
          'chart-5': '185 62% 15%',
          radius: '0.125rem',
          sidebar: '196 52% 8%',
          'sidebar-foreground': '180 77% 61%',
          'sidebar-primary': '180 77% 61%',
          'sidebar-primary-foreground': '196 52% 8%',
          'sidebar-accent': '191 59% 21%',
          'sidebar-accent-foreground': '180 77% 61%',
          'sidebar-border': '191 59% 21%',
          'sidebar-ring': '180 77% 61%',
          'font-sans': 'Source Code Pro, monospace',
          'font-serif': 'Source Code Pro, monospace',
          'font-mono': 'Source Code Pro, monospace',
          'shadow-color': '180 70% 60% / 0.2',
          'shadow-opacity': '0.2',
          'shadow-blur': '2px',
          'shadow-spread': '0px',
          'shadow-offset-x': '1px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '1px 1px 2px 0px hsl(180 70% 60% / 0.10)',
          'shadow-xs': '1px 1px 2px 0px hsl(180 70% 60% / 0.10)',
          'shadow-sm': '1px 1px 2px 0px hsl(180 70% 60% / 0.20), 1px 1px 2px -1px hsl(180 70% 60% / 0.20)',
          shadow: '1px 1px 2px 0px hsl(180 70% 60% / 0.20), 1px 1px 2px -1px hsl(180 70% 60% / 0.20)',
          'shadow-md': '1px 1px 2px 0px hsl(180 70% 60% / 0.20), 1px 2px 4px -1px hsl(180 70% 60% / 0.20)',
          'shadow-lg': '1px 1px 2px 0px hsl(180 70% 60% / 0.20), 1px 4px 6px -1px hsl(180 70% 60% / 0.20)',
          'shadow-xl': '1px 1px 2px 0px hsl(180 70% 60% / 0.20), 1px 8px 10px -1px hsl(180 70% 60% / 0.20)',
          'shadow-2xl': '1px 1px 2px 0px hsl(180 70% 60% / 0.50)',
        },
      },
    },
    {
      name: 'kodama-grove',
      type: 'registry:style',
      title: 'Kodama Grove',
      description: 'A theme based on the Kodama Grove color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Merriweather, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'font-serif': 'Source Serif 4, serif',
          radius: '0.425rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '45 49% 79%',
          foreground: '26 19% 30%',
          card: '42 45% 83%',
          'card-foreground': '26 19% 30%',
          popover: '44 58% 89%',
          'popover-foreground': '26 19% 30%',
          primary: '72 33% 46%',
          'primary-foreground': '43 63% 98%',
          secondary: '45 48% 75%',
          'secondary-foreground': '26 19% 30%',
          muted: '45 48% 75%',
          'muted-foreground': '27 11% 47%',
          accent: '44 50% 72%',
          'accent-foreground': '26 19% 30%',
          destructive: '9 55% 67%',
          'destructive-foreground': '45 44% 96%',
          border: '26 24% 60%',
          input: '44 50% 72%',
          ring: '92 19% 62%',
          'chart-1': '92 19% 62%',
          'chart-2': '95 16% 55%',
          'chart-3': '103 16% 75%',
          'chart-4': '104 11% 47%',
          'chart-5': '104 11% 39%',
          radius: '0.425rem',
          sidebar: '44 52% 76%',
          'sidebar-foreground': '26 19% 30%',
          'sidebar-primary': '92 19% 62%',
          'sidebar-primary-foreground': '43 63% 98%',
          'sidebar-accent': '42 29% 88%',
          'sidebar-accent-foreground': '26 19% 30%',
          'sidebar-border': '42 25% 86%',
          'sidebar-ring': '92 19% 62%',
          'font-sans': 'Merriweather, serif',
          'font-serif': 'Source Serif 4, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '88 22% 35% / 0.15',
          'shadow-opacity': '0.15',
          'shadow-blur': '2px',
          'shadow-spread': '0px',
          'shadow-offset-x': '3px',
          'shadow-offset-y': '3px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '3px 3px 2px 0px hsl(88 22% 35% / 0.07)',
          'shadow-xs': '3px 3px 2px 0px hsl(88 22% 35% / 0.07)',
          'shadow-sm': '3px 3px 2px 0px hsl(88 22% 35% / 0.15), 3px 1px 2px -1px hsl(88 22% 35% / 0.15)',
          shadow: '3px 3px 2px 0px hsl(88 22% 35% / 0.15), 3px 1px 2px -1px hsl(88 22% 35% / 0.15)',
          'shadow-md': '3px 3px 2px 0px hsl(88 22% 35% / 0.15), 3px 2px 4px -1px hsl(88 22% 35% / 0.15)',
          'shadow-lg': '3px 3px 2px 0px hsl(88 22% 35% / 0.15), 3px 4px 6px -1px hsl(88 22% 35% / 0.15)',
          'shadow-xl': '3px 3px 2px 0px hsl(88 22% 35% / 0.15), 3px 8px 10px -1px hsl(88 22% 35% / 0.15)',
          'shadow-2xl': '3px 3px 2px 0px hsl(88 22% 35% / 0.38)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '42 17% 19%',
          foreground: '38 41% 88%',
          card: '39 12% 23%',
          'card-foreground': '38 41% 88%',
          popover: '39 12% 23%',
          'popover-foreground': '38 41% 88%',
          primary: '95 16% 55%',
          'primary-foreground': '27 12% 15%',
          secondary: '40 13% 31%',
          'secondary-foreground': '38 41% 88%',
          muted: '39 13% 26%',
          'muted-foreground': '33 9% 62%',
          accent: '44 27% 50%',
          'accent-foreground': '27 12% 15%',
          destructive: '10 34% 56%',
          'destructive-foreground': '40 41% 90%',
          border: '40 13% 31%',
          input: '40 13% 31%',
          ring: '95 16% 55%',
          'chart-1': '95 16% 55%',
          'chart-2': '92 19% 62%',
          'chart-3': '104 11% 47%',
          'chart-4': '44 27% 50%',
          'chart-5': '104 11% 39%',
          radius: '0.425rem',
          sidebar: '42 17% 19%',
          'sidebar-foreground': '38 41% 88%',
          'sidebar-primary': '95 16% 55%',
          'sidebar-primary-foreground': '27 12% 15%',
          'sidebar-accent': '44 27% 50%',
          'sidebar-accent-foreground': '27 12% 15%',
          'sidebar-border': '40 13% 31%',
          'sidebar-ring': '95 16% 55%',
          'font-sans': 'Merriweather, serif',
          'font-serif': 'Source Serif 4, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '88 22% 35% / 0.15',
          'shadow-opacity': '0.15',
          'shadow-blur': '2px',
          'shadow-spread': '0px',
          'shadow-offset-x': '3px',
          'shadow-offset-y': '3px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '3px 3px 2px 0px hsl(88 22% 35% / 0.07)',
          'shadow-xs': '3px 3px 2px 0px hsl(88 22% 35% / 0.07)',
          'shadow-sm': '3px 3px 2px 0px hsl(88 22% 35% / 0.15), 3px 1px 2px -1px hsl(88 22% 35% / 0.15)',
          shadow: '3px 3px 2px 0px hsl(88 22% 35% / 0.15), 3px 1px 2px -1px hsl(88 22% 35% / 0.15)',
          'shadow-md': '3px 3px 2px 0px hsl(88 22% 35% / 0.15), 3px 2px 4px -1px hsl(88 22% 35% / 0.15)',
          'shadow-lg': '3px 3px 2px 0px hsl(88 22% 35% / 0.15), 3px 4px 6px -1px hsl(88 22% 35% / 0.15)',
          'shadow-xl': '3px 3px 2px 0px hsl(88 22% 35% / 0.15), 3px 8px 10px -1px hsl(88 22% 35% / 0.15)',
          'shadow-2xl': '3px 3px 2px 0px hsl(88 22% 35% / 0.38)',
        },
      },
    },
    {
      name: 'cosmic-night',
      type: 'registry:style',
      title: 'Cosmic Night',
      description: 'A theme based on the Cosmic Night color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Inter, sans-serif',
          'font-mono': 'JetBrains Mono, monospace',
          'font-serif': 'Georgia, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '240 100% 98%',
          foreground: '240 28% 23%',
          card: '0 0% 100%',
          'card-foreground': '240 28% 23%',
          popover: '0 0% 100%',
          'popover-foreground': '240 28% 23%',
          primary: '252 56% 57%',
          'primary-foreground': '0 0% 100%',
          secondary: '249 100% 94%',
          'secondary-foreground': '249 33% 38%',
          muted: '240 50% 96%',
          'muted-foreground': '240 12% 48%',
          accent: '218 100% 92%',
          'accent-foreground': '240 28% 23%',
          destructive: '350 100% 66%',
          'destructive-foreground': '0 0% 100%',
          border: '240 35% 91%',
          input: '240 35% 91%',
          ring: '252 56% 57%',
          'chart-1': '252 56% 57%',
          'chart-2': '250 95% 77%',
          'chart-3': '239 82% 65%',
          'chart-4': '243 93% 72%',
          'chart-5': '244 47% 48%',
          radius: '0.5rem',
          sidebar: '240 50% 96%',
          'sidebar-foreground': '240 28% 23%',
          'sidebar-primary': '252 56% 57%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '218 100% 92%',
          'sidebar-accent-foreground': '240 28% 23%',
          'sidebar-border': '240 35% 91%',
          'sidebar-ring': '252 56% 57%',
          'font-sans': 'Inter, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '240 30% 25%',
          'shadow-opacity': '0.12',
          'shadow-blur': '10px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 10px 0px hsl(240 30% 25% / 0.06)',
          'shadow-xs': '0px 4px 10px 0px hsl(240 30% 25% / 0.06)',
          'shadow-sm': '0px 4px 10px 0px hsl(240 30% 25% / 0.12), 0px 1px 2px -1px hsl(240 30% 25% / 0.12)',
          shadow: '0px 4px 10px 0px hsl(240 30% 25% / 0.12), 0px 1px 2px -1px hsl(240 30% 25% / 0.12)',
          'shadow-md': '0px 4px 10px 0px hsl(240 30% 25% / 0.12), 0px 2px 4px -1px hsl(240 30% 25% / 0.12)',
          'shadow-lg': '0px 4px 10px 0px hsl(240 30% 25% / 0.12), 0px 4px 6px -1px hsl(240 30% 25% / 0.12)',
          'shadow-xl': '0px 4px 10px 0px hsl(240 30% 25% / 0.12), 0px 8px 10px -1px hsl(240 30% 25% / 0.12)',
          'shadow-2xl': '0px 4px 10px 0px hsl(240 30% 25% / 0.30)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '240 27% 8%',
          foreground: '240 49% 92%',
          card: '240 28% 14%',
          'card-foreground': '240 49% 92%',
          popover: '240 28% 14%',
          'popover-foreground': '240 49% 92%',
          primary: '251 100% 78%',
          'primary-foreground': '240 27% 8%',
          secondary: '243 33% 25%',
          'secondary-foreground': '242 100% 88%',
          muted: '240 33% 20%',
          'muted-foreground': '240 20% 69%',
          accent: '240 33% 28%',
          'accent-foreground': '240 49% 92%',
          destructive: '350 100% 66%',
          'destructive-foreground': '0 0% 100%',
          border: '240 26% 25%',
          input: '240 26% 25%',
          ring: '251 100% 78%',
          'chart-1': '251 100% 78%',
          'chart-2': '230 44% 64%',
          'chart-3': '207 89% 68%',
          'chart-4': '174 42% 51%',
          'chart-5': '326 100% 74%',
          radius: '0.5rem',
          sidebar: '240 28% 14%',
          'sidebar-foreground': '240 49% 92%',
          'sidebar-primary': '251 100% 78%',
          'sidebar-primary-foreground': '240 27% 8%',
          'sidebar-accent': '240 33% 28%',
          'sidebar-accent-foreground': '240 49% 92%',
          'sidebar-border': '240 26% 25%',
          'sidebar-ring': '251 100% 78%',
          'font-sans': 'Inter, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '240 30% 25%',
          'shadow-opacity': '0.12',
          'shadow-blur': '10px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 10px 0px hsl(240 30% 25% / 0.06)',
          'shadow-xs': '0px 4px 10px 0px hsl(240 30% 25% / 0.06)',
          'shadow-sm': '0px 4px 10px 0px hsl(240 30% 25% / 0.12), 0px 1px 2px -1px hsl(240 30% 25% / 0.12)',
          shadow: '0px 4px 10px 0px hsl(240 30% 25% / 0.12), 0px 1px 2px -1px hsl(240 30% 25% / 0.12)',
          'shadow-md': '0px 4px 10px 0px hsl(240 30% 25% / 0.12), 0px 2px 4px -1px hsl(240 30% 25% / 0.12)',
          'shadow-lg': '0px 4px 10px 0px hsl(240 30% 25% / 0.12), 0px 4px 6px -1px hsl(240 30% 25% / 0.12)',
          'shadow-xl': '0px 4px 10px 0px hsl(240 30% 25% / 0.12), 0px 8px 10px -1px hsl(240 30% 25% / 0.12)',
          'shadow-2xl': '0px 4px 10px 0px hsl(240 30% 25% / 0.30)',
        },
      },
    },
    {
      name: 'tangerine',
      type: 'registry:style',
      title: 'Tangerine',
      description: 'A theme based on the Tangerine color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Inter, sans-serif',
          'font-mono': 'JetBrains Mono, monospace',
          'font-serif': 'Source Serif 4, serif',
          radius: '0.75rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '204 12% 92%',
          foreground: '0 0% 20%',
          card: '0 0% 100%',
          'card-foreground': '0 0% 20%',
          popover: '0 0% 100%',
          'popover-foreground': '0 0% 20%',
          primary: '13 73% 55%',
          'primary-foreground': '0 0% 100%',
          secondary: '220 14% 96%',
          'secondary-foreground': '215 14% 34%',
          muted: '210 20% 98%',
          'muted-foreground': '220 9% 46%',
          accent: '208 46% 89%',
          'accent-foreground': '224 64% 33%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '210 9% 87%',
          input: '220 16% 96%',
          ring: '13 73% 55%',
          'chart-1': '210 37% 65%',
          'chart-2': '13 73% 75%',
          'chart-3': '213 30% 50%',
          'chart-4': '217 36% 43%',
          'chart-5': '221 44% 35%',
          radius: '0.75rem',
          sidebar: '216 8% 88%',
          'sidebar-foreground': '0 0% 20%',
          'sidebar-primary': '13 73% 55%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '208 46% 89%',
          'sidebar-accent-foreground': '224 64% 33%',
          'sidebar-border': '220 13% 91%',
          'sidebar-ring': '13 73% 55%',
          'font-sans': 'Inter, sans-serif',
          'font-serif': 'Source Serif 4, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0px 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0px 1px 3px 0px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '219 29% 15%',
          foreground: '120 0% 90%',
          card: '224 21% 21%',
          'card-foreground': '120 0% 90%',
          popover: '223 19% 18%',
          'popover-foreground': '120 0% 90%',
          primary: '13 73% 55%',
          'primary-foreground': '0 0% 100%',
          secondary: '222 19% 20%',
          'secondary-foreground': '120 0% 90%',
          muted: '222 19% 20%',
          'muted-foreground': '120 0% 64%',
          accent: '224 34% 25%',
          'accent-foreground': '213 97% 87%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '224 16% 28%',
          input: '224 16% 28%',
          ring: '13 73% 55%',
          'chart-1': '210 37% 65%',
          'chart-2': '12 63% 73%',
          'chart-3': '213 30% 50%',
          'chart-4': '217 36% 43%',
          'chart-5': '221 44% 35%',
          radius: '0.75rem',
          sidebar: '223 20% 21%',
          'sidebar-foreground': '120 0% 90%',
          'sidebar-primary': '13 73% 55%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '224 34% 25%',
          'sidebar-accent-foreground': '213 97% 87%',
          'sidebar-border': '224 16% 28%',
          'sidebar-ring': '13 73% 55%',
          'font-sans': 'Inter, sans-serif',
          'font-serif': 'Source Serif 4, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0px 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0px 1px 3px 0px hsl(0 0% 0% / 0.10), 0px 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0px 1px 3px 0px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'quantum-rose',
      type: 'registry:style',
      title: 'Quantum Rose',
      description: 'A theme based on the Quantum Rose color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Quicksand, sans-serif',
          'font-mono': 'Space Mono, monospace',
          'font-serif': 'Playfair Display, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '328 100% 97%',
          foreground: '326 72% 33%',
          card: '323 100% 98%',
          'card-foreground': '326 72% 33%',
          popover: '323 100% 98%',
          'popover-foreground': '326 72% 33%',
          primary: '329 95% 46%',
          'primary-foreground': '0 0% 100%',
          secondary: '300 100% 92%',
          'secondary-foreground': '326 72% 33%',
          muted: '328 100% 95%',
          'muted-foreground': '329 50% 51%',
          accent: '327 100% 88%',
          'accent-foreground': '326 72% 33%',
          destructive: '341 62% 52%',
          'destructive-foreground': '0 0% 100%',
          border: '327 100% 89%',
          input: '300 100% 92%',
          ring: '329 95% 46%',
          'chart-1': '329 95% 46%',
          'chart-2': '322 51% 53%',
          'chart-3': '277 35% 56%',
          'chart-4': '242 38% 60%',
          'chart-5': '226 100% 68%',
          radius: '0.5rem',
          sidebar: '330 100% 96%',
          'sidebar-foreground': '326 72% 33%',
          'sidebar-primary': '329 95% 46%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '327 100% 88%',
          'sidebar-accent-foreground': '326 72% 33%',
          'sidebar-border': '326 100% 93%',
          'sidebar-ring': '329 95% 46%',
          'font-sans': 'Poppins, sans-serif',
          'font-serif': 'Playfair Display, serif',
          'font-mono': 'Space Mono, monospace',
          'shadow-color': '330 70% 30% / 0.12',
          'shadow-opacity': '0.18',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '3px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 3px 0px 0px hsl(330 70% 30% / 0.09)',
          'shadow-xs': '0px 3px 0px 0px hsl(330 70% 30% / 0.09)',
          'shadow-sm': '0px 3px 0px 0px hsl(330 70% 30% / 0.18), 0px 1px 2px -1px hsl(330 70% 30% / 0.18)',
          shadow: '0px 3px 0px 0px hsl(330 70% 30% / 0.18), 0px 1px 2px -1px hsl(330 70% 30% / 0.18)',
          'shadow-md': '0px 3px 0px 0px hsl(330 70% 30% / 0.18), 0px 2px 4px -1px hsl(330 70% 30% / 0.18)',
          'shadow-lg': '0px 3px 0px 0px hsl(330 70% 30% / 0.18), 0px 4px 6px -1px hsl(330 70% 30% / 0.18)',
          'shadow-xl': '0px 3px 0px 0px hsl(330 70% 30% / 0.18), 0px 8px 10px -1px hsl(330 70% 30% / 0.18)',
          'shadow-2xl': '0px 3px 0px 0px hsl(330 70% 30% / 0.45)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '281 58% 8%',
          foreground: '300 100% 85%',
          card: '280 45% 14%',
          'card-foreground': '300 100% 85%',
          popover: '280 45% 14%',
          'popover-foreground': '300 100% 85%',
          primary: '306 100% 71%',
          'primary-foreground': '300 66% 6%',
          secondary: '289 42% 22%',
          'secondary-foreground': '300 100% 85%',
          muted: '279 44% 18%',
          'muted-foreground': '300 53% 66%',
          accent: '297 50% 24%',
          'accent-foreground': '300 100% 85%',
          destructive: '338 100% 58%',
          'destructive-foreground': '180 0% 98%',
          border: '281 56% 24%',
          input: '289 42% 22%',
          ring: '306 100% 71%',
          'chart-1': '306 100% 71%',
          'chart-2': '286 71% 62%',
          'chart-3': '258 100% 69%',
          'chart-4': '238 66% 66%',
          'chart-5': '227 100% 66%',
          radius: '0.5rem',
          sidebar: '277 48% 10%',
          'sidebar-foreground': '300 100% 85%',
          'sidebar-primary': '306 100% 71%',
          'sidebar-primary-foreground': '300 66% 6%',
          'sidebar-accent': '297 50% 24%',
          'sidebar-accent-foreground': '300 100% 85%',
          'sidebar-border': '281 56% 24%',
          'sidebar-ring': '306 100% 71%',
          'font-sans': 'Quicksand, sans-serif',
          'font-serif': 'Playfair Display, serif',
          'font-mono': 'Space Mono, monospace',
          'shadow-color': '300 80% 50% / 0.25',
          'shadow-opacity': '0.18',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '3px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 3px 0px 0px hsl(300 80% 50% / 0.09)',
          'shadow-xs': '0px 3px 0px 0px hsl(300 80% 50% / 0.09)',
          'shadow-sm': '0px 3px 0px 0px hsl(300 80% 50% / 0.18), 0px 1px 2px -1px hsl(300 80% 50% / 0.18)',
          shadow: '0px 3px 0px 0px hsl(300 80% 50% / 0.18), 0px 1px 2px -1px hsl(300 80% 50% / 0.18)',
          'shadow-md': '0px 3px 0px 0px hsl(300 80% 50% / 0.18), 0px 2px 4px -1px hsl(300 80% 50% / 0.18)',
          'shadow-lg': '0px 3px 0px 0px hsl(300 80% 50% / 0.18), 0px 4px 6px -1px hsl(300 80% 50% / 0.18)',
          'shadow-xl': '0px 3px 0px 0px hsl(300 80% 50% / 0.18), 0px 8px 10px -1px hsl(300 80% 50% / 0.18)',
          'shadow-2xl': '0px 3px 0px 0px hsl(300 80% 50% / 0.45)',
        },
      },
    },
    {
      name: 'nature',
      type: 'registry:style',
      title: 'Nature',
      description: 'A theme based on the Nature color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Montserrat, sans-serif',
          'font-mono': 'Source Code Pro, monospace',
          'font-serif': 'Merriweather, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '38 36% 96%',
          foreground: '9 28% 19%',
          card: '38 36% 96%',
          'card-foreground': '9 28% 19%',
          popover: '38 36% 96%',
          'popover-foreground': '9 28% 19%',
          primary: '123 46% 34%',
          'primary-foreground': '0 0% 100%',
          secondary: '125 39% 94%',
          'secondary-foreground': '124 55% 24%',
          muted: '34 35% 91%',
          'muted-foreground': '15 25% 34%',
          accent: '122 38% 84%',
          'accent-foreground': '124 55% 24%',
          destructive: '0 66% 47%',
          'destructive-foreground': '0 0% 100%',
          border: '34 27% 83%',
          input: '34 27% 83%',
          ring: '123 46% 34%',
          'chart-1': '122 39% 49%',
          'chart-2': '123 43% 39%',
          'chart-3': '123 46% 34%',
          'chart-4': '124 55% 24%',
          'chart-5': '126 51% 8%',
          radius: '0.5rem',
          sidebar: '34 35% 91%',
          'sidebar-foreground': '9 28% 19%',
          'sidebar-primary': '123 46% 34%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '122 38% 84%',
          'sidebar-accent-foreground': '124 55% 24%',
          'sidebar-border': '34 27% 83%',
          'sidebar-ring': '123 46% 34%',
          'font-sans': 'Montserrat, sans-serif',
          'font-serif': 'Merriweather, serif',
          'font-mono': 'Source Code Pro, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '133 20% 14%',
          foreground: '33 27% 92%',
          card: '125 13% 20%',
          'card-foreground': '33 27% 92%',
          popover: '125 13% 20%',
          'popover-foreground': '33 27% 92%',
          primary: '122 39% 49%',
          'primary-foreground': '126 51% 8%',
          secondary: '115 10% 26%',
          'secondary-foreground': '114 14% 86%',
          muted: '126 12% 16%',
          'muted-foreground': '35 19% 81%',
          accent: '123 43% 39%',
          'accent-foreground': '33 27% 92%',
          destructive: '0 66% 47%',
          'destructive-foreground': '33 27% 92%',
          border: '115 10% 26%',
          input: '115 10% 26%',
          ring: '122 39% 49%',
          'chart-1': '123 38% 64%',
          'chart-2': '123 38% 57%',
          'chart-3': '122 39% 49%',
          'chart-4': '123 41% 45%',
          'chart-5': '123 43% 39%',
          radius: '0.5rem',
          sidebar: '133 20% 14%',
          'sidebar-foreground': '33 27% 92%',
          'sidebar-primary': '122 39% 49%',
          'sidebar-primary-foreground': '126 51% 8%',
          'sidebar-accent': '123 43% 39%',
          'sidebar-accent-foreground': '33 27% 92%',
          'sidebar-border': '115 10% 26%',
          'sidebar-ring': '122 39% 49%',
          'font-sans': 'Montserrat, sans-serif',
          'font-serif': 'Merriweather, serif',
          'font-mono': 'Source Code Pro, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'bold-tech',
      type: 'registry:style',
      title: 'Bold Tech',
      description: 'A theme based on the Bold Tech color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Roboto, sans-serif',
          'font-mono': 'Fira Code, monospace',
          'font-serif': 'Playfair Display, serif',
          radius: '0.625rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '0 0% 100%',
          foreground: '242 47% 34%',
          card: '0 0% 100%',
          'card-foreground': '242 47% 34%',
          popover: '0 0% 100%',
          'popover-foreground': '242 47% 34%',
          primary: '258 90% 66%',
          'primary-foreground': '0 0% 100%',
          secondary: '252 100% 97%',
          'secondary-foreground': '245 58% 51%',
          muted: '250 100% 98%',
          'muted-foreground': '262 83% 58%',
          accent: '214 95% 93%',
          'accent-foreground': '226 71% 40%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '226 100% 94%',
          input: '226 100% 94%',
          ring: '258 90% 66%',
          'chart-1': '258 90% 66%',
          'chart-2': '262 83% 58%',
          'chart-3': '263 70% 50%',
          'chart-4': '263 69% 42%',
          'chart-5': '264 67% 35%',
          radius: '0.625rem',
          sidebar: '250 100% 98%',
          'sidebar-foreground': '242 47% 34%',
          'sidebar-primary': '258 90% 66%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '214 95% 93%',
          'sidebar-accent-foreground': '226 71% 40%',
          'sidebar-border': '226 100% 94%',
          'sidebar-ring': '258 90% 66%',
          'font-sans': 'Roboto, sans-serif',
          'font-serif': 'Playfair Display, serif',
          'font-mono': 'Fira Code, monospace',
          'shadow-color': '255 86% 66%',
          'shadow-opacity': '0.2',
          'shadow-blur': '4px',
          'shadow-spread': '0px',
          'shadow-offset-x': '2px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '2px 2px 4px 0px hsl(255 86% 66% / 0.10)',
          'shadow-xs': '2px 2px 4px 0px hsl(255 86% 66% / 0.10)',
          'shadow-sm': '2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 1px 2px -1px hsl(255 86% 66% / 0.20)',
          shadow: '2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 1px 2px -1px hsl(255 86% 66% / 0.20)',
          'shadow-md': '2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 2px 4px -1px hsl(255 86% 66% / 0.20)',
          'shadow-lg': '2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 4px 6px -1px hsl(255 86% 66% / 0.20)',
          'shadow-xl': '2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 8px 10px -1px hsl(255 86% 66% / 0.20)',
          'shadow-2xl': '2px 2px 4px 0px hsl(255 86% 66% / 0.50)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '222 47% 11%',
          foreground: '226 100% 94%',
          card: '244 47% 20%',
          'card-foreground': '226 100% 94%',
          popover: '244 47% 20%',
          'popover-foreground': '226 100% 94%',
          primary: '258 90% 66%',
          'primary-foreground': '0 0% 100%',
          secondary: '244 47% 20%',
          'secondary-foreground': '226 100% 94%',
          muted: '244 56% 18%',
          'muted-foreground': '253 95% 85%',
          accent: '245 58% 51%',
          'accent-foreground': '226 100% 94%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '261 73% 23%',
          input: '261 73% 23%',
          ring: '258 90% 66%',
          'chart-1': '255 92% 76%',
          'chart-2': '258 90% 66%',
          'chart-3': '262 83% 58%',
          'chart-4': '263 70% 50%',
          'chart-5': '263 69% 42%',
          radius: '0.625rem',
          sidebar: '222 47% 11%',
          'sidebar-foreground': '226 100% 94%',
          'sidebar-primary': '258 90% 66%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '245 58% 51%',
          'sidebar-accent-foreground': '226 100% 94%',
          'sidebar-border': '261 73% 23%',
          'sidebar-ring': '258 90% 66%',
          'font-sans': 'Roboto, sans-serif',
          'font-serif': 'Playfair Display, serif',
          'font-mono': 'Fira Code, monospace',
          'shadow-color': '255 86% 66%',
          'shadow-opacity': '0.2',
          'shadow-blur': '4px',
          'shadow-spread': '0px',
          'shadow-offset-x': '2px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '2px 2px 4px 0px hsl(255 86% 66% / 0.10)',
          'shadow-xs': '2px 2px 4px 0px hsl(255 86% 66% / 0.10)',
          'shadow-sm': '2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 1px 2px -1px hsl(255 86% 66% / 0.20)',
          shadow: '2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 1px 2px -1px hsl(255 86% 66% / 0.20)',
          'shadow-md': '2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 2px 4px -1px hsl(255 86% 66% / 0.20)',
          'shadow-lg': '2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 4px 6px -1px hsl(255 86% 66% / 0.20)',
          'shadow-xl': '2px 2px 4px 0px hsl(255 86% 66% / 0.20), 2px 8px 10px -1px hsl(255 86% 66% / 0.20)',
          'shadow-2xl': '2px 2px 4px 0px hsl(255 86% 66% / 0.50)',
        },
      },
    },
    {
      name: 'elegant-luxury',
      type: 'registry:style',
      title: 'Elegant Luxury',
      description: 'A theme based on the Elegant Luxury color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Poppins, sans-serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'font-serif': 'Libre Baskerville, serif',
          radius: '0.375rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '24 34% 97%',
          foreground: '150 0% 10%',
          card: '24 34% 97%',
          'card-foreground': '150 0% 10%',
          popover: '24 34% 97%',
          'popover-foreground': '150 0% 10%',
          primary: '0 56% 39%',
          'primary-foreground': '0 0% 100%',
          secondary: '43 91% 92%',
          'secondary-foreground': '40 100% 25%',
          muted: '23 21% 93%',
          'muted-foreground': '33 5% 32%',
          accent: '48 96% 89%',
          'accent-foreground': '360 63% 31%',
          destructive: '0 70% 35%',
          'destructive-foreground': '0 0% 100%',
          border: '38 64% 89%',
          input: '38 64% 89%',
          ring: '0 56% 39%',
          'chart-1': '360 74% 42%',
          'chart-2': '0 56% 39%',
          'chart-3': '360 63% 31%',
          'chart-4': '26 90% 37%',
          'chart-5': '23 82% 31%',
          radius: '0.375rem',
          sidebar: '23 21% 93%',
          'sidebar-foreground': '150 0% 10%',
          'sidebar-primary': '0 56% 39%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '48 96% 89%',
          'sidebar-accent-foreground': '360 63% 31%',
          'sidebar-border': '38 64% 89%',
          'sidebar-ring': '0 56% 39%',
          'font-sans': 'Poppins, sans-serif',
          'font-serif': 'Libre Baskerville, serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'shadow-color': '0 63% 18%',
          'shadow-opacity': '0.12',
          'shadow-blur': '16px',
          'shadow-spread': '-2px',
          'shadow-offset-x': '1px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '1px 1px 16px -2px hsl(0 63% 18% / 0.06)',
          'shadow-xs': '1px 1px 16px -2px hsl(0 63% 18% / 0.06)',
          'shadow-sm': '1px 1px 16px -2px hsl(0 63% 18% / 0.12), 1px 1px 2px -3px hsl(0 63% 18% / 0.12)',
          shadow: '1px 1px 16px -2px hsl(0 63% 18% / 0.12), 1px 1px 2px -3px hsl(0 63% 18% / 0.12)',
          'shadow-md': '1px 1px 16px -2px hsl(0 63% 18% / 0.12), 1px 2px 4px -3px hsl(0 63% 18% / 0.12)',
          'shadow-lg': '1px 1px 16px -2px hsl(0 63% 18% / 0.12), 1px 4px 6px -3px hsl(0 63% 18% / 0.12)',
          'shadow-xl': '1px 1px 16px -2px hsl(0 63% 18% / 0.12), 1px 8px 10px -3px hsl(0 63% 18% / 0.12)',
          'shadow-2xl': '1px 1px 16px -2px hsl(0 63% 18% / 0.30)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '24 10% 10%',
          foreground: '60 5% 96%',
          card: '12 7% 15%',
          'card-foreground': '60 5% 96%',
          popover: '12 7% 15%',
          'popover-foreground': '60 5% 96%',
          primary: '360 74% 42%',
          'primary-foreground': '24 34% 97%',
          secondary: '23 82% 31%',
          'secondary-foreground': '48 96% 89%',
          muted: '24 9% 11%',
          'muted-foreground': '24 6% 83%',
          accent: '26 90% 37%',
          'accent-foreground': '48 96% 89%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '30 6% 25%',
          input: '30 6% 25%',
          ring: '360 74% 42%',
          'chart-1': '0 91% 71%',
          'chart-2': '0 84% 60%',
          'chart-3': '360 72% 51%',
          'chart-4': '43 96% 56%',
          'chart-5': '38 92% 50%',
          radius: '0.375rem',
          sidebar: '24 10% 10%',
          'sidebar-foreground': '60 5% 96%',
          'sidebar-primary': '360 74% 42%',
          'sidebar-primary-foreground': '24 34% 97%',
          'sidebar-accent': '26 90% 37%',
          'sidebar-accent-foreground': '48 96% 89%',
          'sidebar-border': '30 6% 25%',
          'sidebar-ring': '360 74% 42%',
          'font-sans': 'Poppins, sans-serif',
          'font-serif': 'Libre Baskerville, serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'shadow-color': '0 63% 18%',
          'shadow-opacity': '0.12',
          'shadow-blur': '16px',
          'shadow-spread': '-2px',
          'shadow-offset-x': '1px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '1px 1px 16px -2px hsl(0 63% 18% / 0.06)',
          'shadow-xs': '1px 1px 16px -2px hsl(0 63% 18% / 0.06)',
          'shadow-sm': '1px 1px 16px -2px hsl(0 63% 18% / 0.12), 1px 1px 2px -3px hsl(0 63% 18% / 0.12)',
          shadow: '1px 1px 16px -2px hsl(0 63% 18% / 0.12), 1px 1px 2px -3px hsl(0 63% 18% / 0.12)',
          'shadow-md': '1px 1px 16px -2px hsl(0 63% 18% / 0.12), 1px 2px 4px -3px hsl(0 63% 18% / 0.12)',
          'shadow-lg': '1px 1px 16px -2px hsl(0 63% 18% / 0.12), 1px 4px 6px -3px hsl(0 63% 18% / 0.12)',
          'shadow-xl': '1px 1px 16px -2px hsl(0 63% 18% / 0.12), 1px 8px 10px -3px hsl(0 63% 18% / 0.12)',
          'shadow-2xl': '1px 1px 16px -2px hsl(0 63% 18% / 0.30)',
        },
      },
    },
    {
      name: 'amber-minimal',
      type: 'registry:style',
      title: 'Amber Minimal',
      description: 'A theme based on the Amber Minimal color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Inter, sans-serif',
          'font-mono': 'JetBrains Mono, monospace',
          'font-serif': 'Source Serif 4, serif',
          radius: '0.375rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '0 0% 100%',
          foreground: '0 0% 15%',
          card: '0 0% 100%',
          'card-foreground': '0 0% 15%',
          popover: '0 0% 100%',
          'popover-foreground': '0 0% 15%',
          primary: '38 92% 50%',
          'primary-foreground': '0 0% 0%',
          secondary: '220 14% 96%',
          'secondary-foreground': '215 14% 34%',
          muted: '210 20% 98%',
          'muted-foreground': '220 9% 46%',
          accent: '48 100% 96%',
          'accent-foreground': '23 82% 31%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '220 13% 91%',
          input: '220 13% 91%',
          ring: '38 92% 50%',
          'chart-1': '38 92% 50%',
          'chart-2': '32 95% 44%',
          'chart-3': '26 90% 37%',
          'chart-4': '23 82% 31%',
          'chart-5': '22 78% 26%',
          radius: '0.375rem',
          sidebar: '210 20% 98%',
          'sidebar-foreground': '0 0% 15%',
          'sidebar-primary': '38 92% 50%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '48 100% 96%',
          'sidebar-accent-foreground': '23 82% 31%',
          'sidebar-border': '220 13% 91%',
          'sidebar-ring': '38 92% 50%',
          'font-sans': 'Inter, sans-serif',
          'font-serif': 'Source Serif 4, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '8px',
          'shadow-spread': '-1px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
          shadow: '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 2px 4px -2px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 4px 6px -2px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 8px 10px -2px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '180 0% 9%',
          foreground: '120 0% 90%',
          card: '0 0% 15%',
          'card-foreground': '120 0% 90%',
          popover: '0 0% 15%',
          'popover-foreground': '120 0% 90%',
          primary: '38 92% 50%',
          'primary-foreground': '0 0% 0%',
          secondary: '0 0% 15%',
          'secondary-foreground': '120 0% 90%',
          muted: '0 0% 12%',
          'muted-foreground': '120 0% 64%',
          accent: '23 82% 31%',
          'accent-foreground': '48 97% 77%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '0 0% 25%',
          input: '0 0% 25%',
          ring: '38 92% 50%',
          'chart-1': '43 96% 56%',
          'chart-2': '32 95% 44%',
          'chart-3': '23 82% 31%',
          'chart-4': '26 90% 37%',
          'chart-5': '23 82% 31%',
          radius: '0.375rem',
          sidebar: '300 0% 6%',
          'sidebar-foreground': '120 0% 90%',
          'sidebar-primary': '38 92% 50%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '23 82% 31%',
          'sidebar-accent-foreground': '48 97% 77%',
          'sidebar-border': '0 0% 25%',
          'sidebar-ring': '38 92% 50%',
          'font-sans': 'Inter, sans-serif',
          'font-serif': 'Source Serif 4, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '8px',
          'shadow-spread': '-1px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
          shadow: '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 2px 4px -2px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 4px 6px -2px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 8px 10px -2px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'supabase',
      type: 'registry:style',
      title: 'Supabase',
      description: 'A theme based on the Supabase color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Outfit, sans-serif',
          'font-mono': 'monospace',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '0 0% 99%',
          foreground: '180 0% 9%',
          card: '0 0% 99%',
          'card-foreground': '180 0% 9%',
          popover: '0 0% 99%',
          'popover-foreground': '300 0% 32%',
          primary: '151 67% 67%',
          'primary-foreground': '153 13% 14%',
          secondary: '180 0% 99%',
          'secondary-foreground': '180 0% 9%',
          muted: '180 0% 93%',
          'muted-foreground': '0 0% 13%',
          accent: '180 0% 93%',
          'accent-foreground': '0 0% 13%',
          destructive: '10 82% 44%',
          'destructive-foreground': '0 100% 99%',
          border: '330 0% 87%',
          input: '0 0% 96%',
          ring: '151 67% 67%',
          'chart-1': '151 67% 67%',
          'chart-2': '217 91% 60%',
          'chart-3': '258 90% 66%',
          'chart-4': '38 92% 50%',
          'chart-5': '160 84% 39%',
          radius: '0.5rem',
          sidebar: '0 0% 99%',
          'sidebar-foreground': '180 0% 44%',
          'sidebar-primary': '151 67% 67%',
          'sidebar-primary-foreground': '153 13% 14%',
          'sidebar-accent': '180 0% 93%',
          'sidebar-accent-foreground': '0 0% 13%',
          'sidebar-border': '330 0% 87%',
          'sidebar-ring': '151 67% 67%',
          'font-sans': 'Outfit, sans-serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono': 'monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.17',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0.025em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 1px 3px 0px hsl(0 0% 0% / 0.09)',
          'shadow-xs': '0px 1px 3px 0px hsl(0 0% 0% / 0.09)',
          'shadow-sm': '0px 1px 3px 0px hsl(0 0% 0% / 0.17), 0px 1px 2px -1px hsl(0 0% 0% / 0.17)',
          shadow: '0px 1px 3px 0px hsl(0 0% 0% / 0.17), 0px 1px 2px -1px hsl(0 0% 0% / 0.17)',
          'shadow-md': '0px 1px 3px 0px hsl(0 0% 0% / 0.17), 0px 2px 4px -1px hsl(0 0% 0% / 0.17)',
          'shadow-lg': '0px 1px 3px 0px hsl(0 0% 0% / 0.17), 0px 4px 6px -1px hsl(0 0% 0% / 0.17)',
          'shadow-xl': '0px 1px 3px 0px hsl(0 0% 0% / 0.17), 0px 8px 10px -1px hsl(0 0% 0% / 0.17)',
          'shadow-2xl': '0px 1px 3px 0px hsl(0 0% 0% / 0.43)',
          'tracking-normal': '0.025em',
        },
        dark: {
          background: '0 0% 7%',
          foreground: '214 32% 91%',
          card: '180 0% 9%',
          'card-foreground': '214 32% 91%',
          popover: '180 0% 14%',
          'popover-foreground': '0 0% 66%',
          primary: '155 100% 19%',
          'primary-foreground': '153 19% 89%',
          secondary: '180 0% 14%',
          'secondary-foreground': '60 0% 98%',
          muted: '0 0% 12%',
          'muted-foreground': '180 0% 64%',
          accent: '0 0% 19%',
          'accent-foreground': '60 0% 98%',
          destructive: '7 60% 21%',
          'destructive-foreground': '12 12% 92%',
          border: '180 0% 16%',
          input: '180 0% 14%',
          ring: '142 69% 58%',
          'chart-1': '142 69% 58%',
          'chart-2': '213 94% 68%',
          'chart-3': '255 92% 76%',
          'chart-4': '43 96% 56%',
          'chart-5': '172 66% 50%',
          radius: '0.5rem',
          sidebar: '0 0% 7%',
          'sidebar-foreground': '180 0% 54%',
          'sidebar-primary': '155 100% 19%',
          'sidebar-primary-foreground': '153 19% 89%',
          'sidebar-accent': '0 0% 19%',
          'sidebar-accent-foreground': '60 0% 98%',
          'sidebar-border': '180 0% 16%',
          'sidebar-ring': '142 69% 58%',
          'font-sans': 'Outfit, sans-serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono': 'monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.17',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0.025em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 1px 3px 0px hsl(0 0% 0% / 0.09)',
          'shadow-xs': '0px 1px 3px 0px hsl(0 0% 0% / 0.09)',
          'shadow-sm': '0px 1px 3px 0px hsl(0 0% 0% / 0.17), 0px 1px 2px -1px hsl(0 0% 0% / 0.17)',
          shadow: '0px 1px 3px 0px hsl(0 0% 0% / 0.17), 0px 1px 2px -1px hsl(0 0% 0% / 0.17)',
          'shadow-md': '0px 1px 3px 0px hsl(0 0% 0% / 0.17), 0px 2px 4px -1px hsl(0 0% 0% / 0.17)',
          'shadow-lg': '0px 1px 3px 0px hsl(0 0% 0% / 0.17), 0px 4px 6px -1px hsl(0 0% 0% / 0.17)',
          'shadow-xl': '0px 1px 3px 0px hsl(0 0% 0% / 0.17), 0px 8px 10px -1px hsl(0 0% 0% / 0.17)',
          'shadow-2xl': '0px 1px 3px 0px hsl(0 0% 0% / 0.43)',
        },
      },
    },
    {
      name: 'neo-brutalism',
      type: 'registry:style',
      title: 'Neo Brutalism',
      description: 'A theme based on the Neo Brutalism color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'DM Sans, sans-serif',
          'font-mono': 'Space Mono, monospace',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          radius: '0px',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '0 0% 100%',
          foreground: '0 0% 0%',
          card: '0 0% 100%',
          'card-foreground': '0 0% 0%',
          popover: '0 0% 100%',
          'popover-foreground': '0 0% 0%',
          primary: '360 100% 60%',
          'primary-foreground': '0 0% 100%',
          secondary: '60 100% 50%',
          'secondary-foreground': '0 0% 0%',
          muted: '240 0% 94%',
          'muted-foreground': '0 0% 20%',
          accent: '216 100% 50%',
          'accent-foreground': '0 0% 100%',
          destructive: '0 0% 0%',
          'destructive-foreground': '0 0% 100%',
          border: '0 0% 0%',
          input: '0 0% 0%',
          ring: '360 100% 60%',
          'chart-1': '360 100% 60%',
          'chart-2': '60 100% 50%',
          'chart-3': '216 100% 50%',
          'chart-4': '120 100% 40%',
          'chart-5': '300 100% 40%',
          radius: '0px',
          sidebar: '240 0% 94%',
          'sidebar-foreground': '0 0% 0%',
          'sidebar-primary': '360 100% 60%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '216 100% 50%',
          'sidebar-accent-foreground': '0 0% 100%',
          'sidebar-border': '0 0% 0%',
          'sidebar-ring': '360 100% 60%',
          'font-sans': 'DM Sans, sans-serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono': 'Space Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '1',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '4px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '4px 4px 0px 0px hsl(0 0% 0% / 0.50)',
          'shadow-xs': '4px 4px 0px 0px hsl(0 0% 0% / 0.50)',
          'shadow-sm': '4px 4px 0px 0px hsl(0 0% 0% / 1.00), 4px 1px 2px -1px hsl(0 0% 0% / 1.00)',
          shadow: '4px 4px 0px 0px hsl(0 0% 0% / 1.00), 4px 1px 2px -1px hsl(0 0% 0% / 1.00)',
          'shadow-md': '4px 4px 0px 0px hsl(0 0% 0% / 1.00), 4px 2px 4px -1px hsl(0 0% 0% / 1.00)',
          'shadow-lg': '4px 4px 0px 0px hsl(0 0% 0% / 1.00), 4px 4px 6px -1px hsl(0 0% 0% / 1.00)',
          'shadow-xl': '4px 4px 0px 0px hsl(0 0% 0% / 1.00), 4px 8px 10px -1px hsl(0 0% 0% / 1.00)',
          'shadow-2xl': '4px 4px 0px 0px hsl(0 0% 0% / 2.50)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '0 0% 0%',
          foreground: '0 0% 100%',
          card: '0 0% 20%',
          'card-foreground': '0 0% 100%',
          popover: '0 0% 20%',
          'popover-foreground': '0 0% 100%',
          primary: '360 100% 70%',
          'primary-foreground': '0 0% 0%',
          secondary: '60 100% 60%',
          'secondary-foreground': '0 0% 0%',
          muted: '150 0% 10%',
          'muted-foreground': '180 0% 80%',
          accent: '210 100% 60%',
          'accent-foreground': '0 0% 0%',
          destructive: '0 0% 100%',
          'destructive-foreground': '0 0% 0%',
          border: '0 0% 100%',
          input: '0 0% 100%',
          ring: '360 100% 70%',
          'chart-1': '360 100% 70%',
          'chart-2': '60 100% 60%',
          'chart-3': '210 100% 60%',
          'chart-4': '120 60% 50%',
          'chart-5': '300 60% 50%',
          radius: '0px',
          sidebar: '0 0% 0%',
          'sidebar-foreground': '0 0% 100%',
          'sidebar-primary': '360 100% 70%',
          'sidebar-primary-foreground': '0 0% 0%',
          'sidebar-accent': '210 100% 60%',
          'sidebar-accent-foreground': '0 0% 0%',
          'sidebar-border': '0 0% 100%',
          'sidebar-ring': '360 100% 70%',
          'font-sans': 'DM Sans, sans-serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono': 'Space Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '1',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '4px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '4px 4px 0px 0px hsl(0 0% 0% / 0.50)',
          'shadow-xs': '4px 4px 0px 0px hsl(0 0% 0% / 0.50)',
          'shadow-sm': '4px 4px 0px 0px hsl(0 0% 0% / 1.00), 4px 1px 2px -1px hsl(0 0% 0% / 1.00)',
          shadow: '4px 4px 0px 0px hsl(0 0% 0% / 1.00), 4px 1px 2px -1px hsl(0 0% 0% / 1.00)',
          'shadow-md': '4px 4px 0px 0px hsl(0 0% 0% / 1.00), 4px 2px 4px -1px hsl(0 0% 0% / 1.00)',
          'shadow-lg': '4px 4px 0px 0px hsl(0 0% 0% / 1.00), 4px 4px 6px -1px hsl(0 0% 0% / 1.00)',
          'shadow-xl': '4px 4px 0px 0px hsl(0 0% 0% / 1.00), 4px 8px 10px -1px hsl(0 0% 0% / 1.00)',
          'shadow-2xl': '4px 4px 0px 0px hsl(0 0% 0% / 2.50)',
        },
      },
    },
    {
      name: 'solar-dusk',
      type: 'registry:style',
      title: 'Solar Dusk',
      description: 'A theme based on the Solar Dusk color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Oxanium, sans-serif',
          'font-mono': 'Fira Code, monospace',
          'font-serif': 'Merriweather, serif',
          radius: '0.3rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '40 60% 98%',
          foreground: '21 18% 25%',
          card: '36 42% 95%',
          'card-foreground': '21 18% 25%',
          popover: '36 42% 95%',
          'popover-foreground': '21 18% 25%',
          primary: '26 90% 37%',
          'primary-foreground': '0 0% 100%',
          secondary: '34 61% 73%',
          'secondary-foreground': '33 5% 32%',
          muted: '39 45% 90%',
          'muted-foreground': '25 5% 45%',
          accent: '34 68% 84%',
          'accent-foreground': '33 5% 32%',
          destructive: '0 70% 35%',
          'destructive-foreground': '0 0% 100%',
          border: '44 43% 82%',
          input: '44 43% 82%',
          ring: '26 90% 37%',
          'chart-1': '26 90% 37%',
          'chart-2': '25 5% 45%',
          'chart-3': '35 92% 33%',
          'chart-4': '25 5% 45%',
          'chart-5': '41 96% 40%',
          radius: '0.3rem',
          sidebar: '39 45% 90%',
          'sidebar-foreground': '21 18% 25%',
          'sidebar-primary': '26 90% 37%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '35 92% 33%',
          'sidebar-accent-foreground': '0 0% 100%',
          'sidebar-border': '44 43% 82%',
          'sidebar-ring': '26 90% 37%',
          'font-sans': 'Oxanium, sans-serif',
          'font-serif': 'Merriweather, serif',
          'font-mono': 'Fira Code, monospace',
          'shadow-color': '28 18% 25%',
          'shadow-opacity': '0.18',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 2px 3px 0px hsl(28 18% 25% / 0.09)',
          'shadow-xs': '0px 2px 3px 0px hsl(28 18% 25% / 0.09)',
          'shadow-sm': '0px 2px 3px 0px hsl(28 18% 25% / 0.18), 0px 1px 2px -1px hsl(28 18% 25% / 0.18)',
          shadow: '0px 2px 3px 0px hsl(28 18% 25% / 0.18), 0px 1px 2px -1px hsl(28 18% 25% / 0.18)',
          'shadow-md': '0px 2px 3px 0px hsl(28 18% 25% / 0.18), 0px 2px 4px -1px hsl(28 18% 25% / 0.18)',
          'shadow-lg': '0px 2px 3px 0px hsl(28 18% 25% / 0.18), 0px 4px 6px -1px hsl(28 18% 25% / 0.18)',
          'shadow-xl': '0px 2px 3px 0px hsl(28 18% 25% / 0.18), 0px 8px 10px -1px hsl(28 18% 25% / 0.18)',
          'shadow-2xl': '0px 2px 3px 0px hsl(28 18% 25% / 0.45)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '24 10% 10%',
          foreground: '60 5% 96%',
          card: '12 7% 15%',
          'card-foreground': '60 5% 96%',
          popover: '12 7% 15%',
          'popover-foreground': '60 5% 96%',
          primary: '25 95% 53%',
          'primary-foreground': '0 0% 100%',
          secondary: '33 5% 32%',
          'secondary-foreground': '20 6% 90%',
          muted: '30 10% 11%',
          'muted-foreground': '24 5% 64%',
          accent: '198 46% 22%',
          'accent-foreground': '20 6% 90%',
          destructive: '360 72% 51%',
          'destructive-foreground': '0 0% 100%',
          border: '30 6% 25%',
          input: '30 6% 25%',
          ring: '25 95% 53%',
          'chart-1': '25 95% 53%',
          'chart-2': '199 89% 48%',
          'chart-3': '45 94% 47%',
          'chart-4': '24 5% 64%',
          'chart-5': '25 5% 45%',
          radius: '0.3rem',
          sidebar: '12 7% 15%',
          'sidebar-foreground': '60 5% 96%',
          'sidebar-primary': '25 95% 53%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '199 89% 48%',
          'sidebar-accent-foreground': '212 73% 17%',
          'sidebar-border': '30 6% 25%',
          'sidebar-ring': '25 95% 53%',
          'font-sans': 'Oxanium, sans-serif',
          'font-serif': 'Merriweather, serif',
          'font-mono': 'Fira Code, monospace',
          'shadow-color': '0 0% 5%',
          'shadow-opacity': '0.18',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 2px 3px 0px hsl(0 0% 5% / 0.09)',
          'shadow-xs': '0px 2px 3px 0px hsl(0 0% 5% / 0.09)',
          'shadow-sm': '0px 2px 3px 0px hsl(0 0% 5% / 0.18), 0px 1px 2px -1px hsl(0 0% 5% / 0.18)',
          shadow: '0px 2px 3px 0px hsl(0 0% 5% / 0.18), 0px 1px 2px -1px hsl(0 0% 5% / 0.18)',
          'shadow-md': '0px 2px 3px 0px hsl(0 0% 5% / 0.18), 0px 2px 4px -1px hsl(0 0% 5% / 0.18)',
          'shadow-lg': '0px 2px 3px 0px hsl(0 0% 5% / 0.18), 0px 4px 6px -1px hsl(0 0% 5% / 0.18)',
          'shadow-xl': '0px 2px 3px 0px hsl(0 0% 5% / 0.18), 0px 8px 10px -1px hsl(0 0% 5% / 0.18)',
          'shadow-2xl': '0px 2px 3px 0px hsl(0 0% 5% / 0.45)',
        },
      },
    },
    {
      name: 'claymorphism',
      type: 'registry:style',
      title: 'Claymorphism',
      description: 'A theme based on the Claymorphism color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Plus Jakarta Sans, sans-serif',
          'font-mono': 'Roboto Mono, monospace',
          'font-serif': 'Lora, serif',
          radius: '1.25rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '20 6% 90%',
          foreground: '217 33% 17%',
          card: '60 5% 96%',
          'card-foreground': '217 33% 17%',
          popover: '60 5% 96%',
          'popover-foreground': '217 33% 17%',
          primary: '239 84% 67%',
          'primary-foreground': '0 0% 100%',
          secondary: '24 6% 83%',
          'secondary-foreground': '215 14% 34%',
          muted: '20 6% 90%',
          'muted-foreground': '220 9% 46%',
          accent: '293 44% 93%',
          'accent-foreground': '217 19% 27%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '24 6% 83%',
          input: '24 6% 83%',
          ring: '239 84% 67%',
          'chart-1': '239 84% 67%',
          'chart-2': '243 75% 59%',
          'chart-3': '245 58% 51%',
          'chart-4': '244 54% 41%',
          'chart-5': '242 47% 34%',
          radius: '1.25rem',
          sidebar: '24 6% 83%',
          'sidebar-foreground': '217 33% 17%',
          'sidebar-primary': '239 84% 67%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '293 44% 93%',
          'sidebar-accent-foreground': '217 19% 27%',
          'sidebar-border': '24 6% 83%',
          'sidebar-ring': '239 84% 67%',
          'font-sans': 'Plus Jakarta Sans, sans-serif',
          'font-serif': 'Lora, serif',
          'font-mono': 'Roboto Mono, monospace',
          'shadow-color': '240 4% 60%',
          'shadow-opacity': '0.18',
          'shadow-blur': '10px',
          'shadow-spread': '4px',
          'shadow-offset-x': '2px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '2px 2px 10px 4px hsl(240 4% 60% / 0.09)',
          'shadow-xs': '2px 2px 10px 4px hsl(240 4% 60% / 0.09)',
          'shadow-sm': '2px 2px 10px 4px hsl(240 4% 60% / 0.18), 2px 1px 2px 3px hsl(240 4% 60% / 0.18)',
          shadow: '2px 2px 10px 4px hsl(240 4% 60% / 0.18), 2px 1px 2px 3px hsl(240 4% 60% / 0.18)',
          'shadow-md': '2px 2px 10px 4px hsl(240 4% 60% / 0.18), 2px 2px 4px 3px hsl(240 4% 60% / 0.18)',
          'shadow-lg': '2px 2px 10px 4px hsl(240 4% 60% / 0.18), 2px 4px 6px 3px hsl(240 4% 60% / 0.18)',
          'shadow-xl': '2px 2px 10px 4px hsl(240 4% 60% / 0.18), 2px 8px 10px 3px hsl(240 4% 60% / 0.18)',
          'shadow-2xl': '2px 2px 10px 4px hsl(240 4% 60% / 0.45)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '30 11% 11%',
          foreground: '214 32% 91%',
          card: '26 9% 16%',
          'card-foreground': '214 32% 91%',
          popover: '26 9% 16%',
          'popover-foreground': '214 32% 91%',
          primary: '234 89% 74%',
          'primary-foreground': '30 11% 11%',
          secondary: '26 6% 21%',
          'secondary-foreground': '216 12% 84%',
          muted: '30 11% 11%',
          'muted-foreground': '218 11% 65%',
          accent: '26 5% 27%',
          'accent-foreground': '216 12% 84%',
          destructive: '0 84% 60%',
          'destructive-foreground': '30 11% 11%',
          border: '26 6% 21%',
          input: '26 6% 21%',
          ring: '234 89% 74%',
          'chart-1': '234 89% 74%',
          'chart-2': '239 84% 67%',
          'chart-3': '243 75% 59%',
          'chart-4': '245 58% 51%',
          'chart-5': '244 54% 41%',
          radius: '1.25rem',
          sidebar: '26 6% 21%',
          'sidebar-foreground': '214 32% 91%',
          'sidebar-primary': '234 89% 74%',
          'sidebar-primary-foreground': '30 11% 11%',
          'sidebar-accent': '26 5% 27%',
          'sidebar-accent-foreground': '216 12% 84%',
          'sidebar-border': '26 6% 21%',
          'sidebar-ring': '234 89% 74%',
          'font-sans': 'Plus Jakarta Sans, sans-serif',
          'font-serif': 'Lora, serif',
          'font-mono': 'Roboto Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.18',
          'shadow-blur': '10px',
          'shadow-spread': '4px',
          'shadow-offset-x': '2px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '2px 2px 10px 4px hsl(0 0% 0% / 0.09)',
          'shadow-xs': '2px 2px 10px 4px hsl(0 0% 0% / 0.09)',
          'shadow-sm': '2px 2px 10px 4px hsl(0 0% 0% / 0.18), 2px 1px 2px 3px hsl(0 0% 0% / 0.18)',
          shadow: '2px 2px 10px 4px hsl(0 0% 0% / 0.18), 2px 1px 2px 3px hsl(0 0% 0% / 0.18)',
          'shadow-md': '2px 2px 10px 4px hsl(0 0% 0% / 0.18), 2px 2px 4px 3px hsl(0 0% 0% / 0.18)',
          'shadow-lg': '2px 2px 10px 4px hsl(0 0% 0% / 0.18), 2px 4px 6px 3px hsl(0 0% 0% / 0.18)',
          'shadow-xl': '2px 2px 10px 4px hsl(0 0% 0% / 0.18), 2px 8px 10px 3px hsl(0 0% 0% / 0.18)',
          'shadow-2xl': '2px 2px 10px 4px hsl(0 0% 0% / 0.45)',
        },
      },
    },
    {
      name: 'cyberpunk',
      type: 'registry:style',
      title: 'Cyberpunk',
      description: 'A theme based on the Cyberpunk color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Outfit, sans-serif',
          'font-mono': 'Fira Code, monospace',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '210 17% 98%',
          foreground: '240 41% 8%',
          card: '0 0% 100%',
          'card-foreground': '240 41% 8%',
          popover: '0 0% 100%',
          'popover-foreground': '240 41% 8%',
          primary: '313 100% 50%',
          'primary-foreground': '0 0% 100%',
          secondary: '240 100% 97%',
          'secondary-foreground': '240 41% 8%',
          muted: '240 100% 97%',
          'muted-foreground': '240 41% 8%',
          accent: '168 100% 50%',
          'accent-foreground': '240 41% 8%',
          destructive: '14 100% 50%',
          'destructive-foreground': '0 0% 100%',
          border: '198 19% 89%',
          input: '198 19% 89%',
          ring: '313 100% 50%',
          'chart-1': '313 100% 50%',
          'chart-2': '274 100% 50%',
          'chart-3': '186 100% 50%',
          'chart-4': '168 100% 50%',
          'chart-5': '54 100% 50%',
          radius: '0.5rem',
          sidebar: '240 100% 97%',
          'sidebar-foreground': '240 41% 8%',
          'sidebar-primary': '313 100% 50%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '168 100% 50%',
          'sidebar-accent-foreground': '240 41% 8%',
          'sidebar-border': '198 19% 89%',
          'sidebar-ring': '313 100% 50%',
          'font-sans': 'Outfit, sans-serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono': 'Fira Code, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '8px',
          'shadow-spread': '-2px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 8px -2px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0px 4px 8px -2px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0px 4px 8px -2px hsl(0 0% 0% / 0.10), 0px 1px 2px -3px hsl(0 0% 0% / 0.10)',
          shadow: '0px 4px 8px -2px hsl(0 0% 0% / 0.10), 0px 1px 2px -3px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0px 4px 8px -2px hsl(0 0% 0% / 0.10), 0px 2px 4px -3px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0px 4px 8px -2px hsl(0 0% 0% / 0.10), 0px 4px 6px -3px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0px 4px 8px -2px hsl(0 0% 0% / 0.10), 0px 8px 10px -3px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0px 4px 8px -2px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '240 41% 8%',
          foreground: '217 27% 94%',
          card: '240 35% 18%',
          'card-foreground': '217 27% 94%',
          popover: '240 35% 18%',
          'popover-foreground': '217 27% 94%',
          primary: '313 100% 50%',
          'primary-foreground': '0 0% 100%',
          secondary: '240 35% 18%',
          'secondary-foreground': '217 27% 94%',
          muted: '240 39% 14%',
          'muted-foreground': '232 18% 58%',
          accent: '168 100% 50%',
          'accent-foreground': '240 41% 8%',
          destructive: '14 100% 50%',
          'destructive-foreground': '0 0% 100%',
          border: '240 34% 27%',
          input: '240 34% 27%',
          ring: '313 100% 50%',
          'chart-1': '313 100% 50%',
          'chart-2': '274 100% 50%',
          'chart-3': '186 100% 50%',
          'chart-4': '168 100% 50%',
          'chart-5': '54 100% 50%',
          radius: '0.5rem',
          sidebar: '240 41% 8%',
          'sidebar-foreground': '217 27% 94%',
          'sidebar-primary': '313 100% 50%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '168 100% 50%',
          'sidebar-accent-foreground': '240 41% 8%',
          'sidebar-border': '240 34% 27%',
          'sidebar-ring': '313 100% 50%',
          'font-sans': 'Outfit, sans-serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono': 'Fira Code, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '8px',
          'shadow-spread': '-2px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 8px -2px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0px 4px 8px -2px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0px 4px 8px -2px hsl(0 0% 0% / 0.10), 0px 1px 2px -3px hsl(0 0% 0% / 0.10)',
          shadow: '0px 4px 8px -2px hsl(0 0% 0% / 0.10), 0px 1px 2px -3px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0px 4px 8px -2px hsl(0 0% 0% / 0.10), 0px 2px 4px -3px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0px 4px 8px -2px hsl(0 0% 0% / 0.10), 0px 4px 6px -3px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0px 4px 8px -2px hsl(0 0% 0% / 0.10), 0px 8px 10px -3px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0px 4px 8px -2px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'pastel-dreams',
      type: 'registry:style',
      title: 'Pastel Dreams',
      description: 'A theme based on the Pastel Dreams color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Open Sans, sans-serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'font-serif': 'Source Serif 4, serif',
          radius: '1.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '280 33% 96%',
          foreground: '217 19% 27%',
          card: '0 0% 100%',
          'card-foreground': '217 19% 27%',
          popover: '0 0% 100%',
          'popover-foreground': '217 19% 27%',
          primary: '255 92% 76%',
          'primary-foreground': '0 0% 100%',
          secondary: '268 90% 92%',
          'secondary-foreground': '215 14% 34%',
          muted: '269 100% 95%',
          'muted-foreground': '220 9% 46%',
          accent: '293 44% 93%',
          'accent-foreground': '217 19% 27%',
          destructive: '360 94% 82%',
          'destructive-foreground': '0 0% 100%',
          border: '268 90% 92%',
          input: '268 90% 92%',
          ring: '255 92% 76%',
          'chart-1': '255 92% 76%',
          'chart-2': '258 90% 66%',
          'chart-3': '262 83% 58%',
          'chart-4': '263 70% 50%',
          'chart-5': '263 69% 42%',
          radius: '1.5rem',
          sidebar: '268 90% 92%',
          'sidebar-foreground': '217 19% 27%',
          'sidebar-primary': '255 92% 76%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '293 44% 93%',
          'sidebar-accent-foreground': '217 19% 27%',
          'sidebar-border': '268 90% 92%',
          'sidebar-ring': '255 92% 76%',
          'font-sans': 'Open Sans, sans-serif',
          'font-serif': 'Source Serif 4, serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.08',
          'shadow-blur': '16px',
          'shadow-spread': '-4px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '8px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 8px 16px -4px hsl(0 0% 0% / 0.04)',
          'shadow-xs': '0px 8px 16px -4px hsl(0 0% 0% / 0.04)',
          'shadow-sm': '0px 8px 16px -4px hsl(0 0% 0% / 0.08), 0px 1px 2px -5px hsl(0 0% 0% / 0.08)',
          shadow: '0px 8px 16px -4px hsl(0 0% 0% / 0.08), 0px 1px 2px -5px hsl(0 0% 0% / 0.08)',
          'shadow-md': '0px 8px 16px -4px hsl(0 0% 0% / 0.08), 0px 2px 4px -5px hsl(0 0% 0% / 0.08)',
          'shadow-lg': '0px 8px 16px -4px hsl(0 0% 0% / 0.08), 0px 4px 6px -5px hsl(0 0% 0% / 0.08)',
          'shadow-xl': '0px 8px 16px -4px hsl(0 0% 0% / 0.08), 0px 8px 10px -5px hsl(0 0% 0% / 0.08)',
          'shadow-2xl': '0px 8px 16px -4px hsl(0 0% 0% / 0.20)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '24 10% 10%',
          foreground: '226 100% 94%',
          card: '270 18% 18%',
          'card-foreground': '226 100% 94%',
          popover: '270 18% 18%',
          'popover-foreground': '226 100% 94%',
          primary: '256 95% 83%',
          'primary-foreground': '24 10% 10%',
          secondary: '272 19% 24%',
          'secondary-foreground': '216 12% 84%',
          muted: '265 28% 13%',
          'muted-foreground': '218 11% 65%',
          accent: '267 19% 30%',
          'accent-foreground': '216 12% 84%',
          destructive: '360 94% 82%',
          'destructive-foreground': '24 10% 10%',
          border: '272 19% 24%',
          input: '272 19% 24%',
          ring: '256 95% 83%',
          'chart-1': '256 95% 83%',
          'chart-2': '255 92% 76%',
          'chart-3': '258 90% 66%',
          'chart-4': '262 83% 58%',
          'chart-5': '263 70% 50%',
          radius: '1.5rem',
          sidebar: '272 19% 24%',
          'sidebar-foreground': '226 100% 94%',
          'sidebar-primary': '256 95% 83%',
          'sidebar-primary-foreground': '24 10% 10%',
          'sidebar-accent': '267 19% 30%',
          'sidebar-accent-foreground': '216 12% 84%',
          'sidebar-border': '272 19% 24%',
          'sidebar-ring': '256 95% 83%',
          'font-sans': 'Open Sans, sans-serif',
          'font-serif': 'Source Serif 4, serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.08',
          'shadow-blur': '16px',
          'shadow-spread': '-4px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '8px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 8px 16px -4px hsl(0 0% 0% / 0.04)',
          'shadow-xs': '0px 8px 16px -4px hsl(0 0% 0% / 0.04)',
          'shadow-sm': '0px 8px 16px -4px hsl(0 0% 0% / 0.08), 0px 1px 2px -5px hsl(0 0% 0% / 0.08)',
          shadow: '0px 8px 16px -4px hsl(0 0% 0% / 0.08), 0px 1px 2px -5px hsl(0 0% 0% / 0.08)',
          'shadow-md': '0px 8px 16px -4px hsl(0 0% 0% / 0.08), 0px 2px 4px -5px hsl(0 0% 0% / 0.08)',
          'shadow-lg': '0px 8px 16px -4px hsl(0 0% 0% / 0.08), 0px 4px 6px -5px hsl(0 0% 0% / 0.08)',
          'shadow-xl': '0px 8px 16px -4px hsl(0 0% 0% / 0.08), 0px 8px 10px -5px hsl(0 0% 0% / 0.08)',
          'shadow-2xl': '0px 8px 16px -4px hsl(0 0% 0% / 0.20)',
        },
      },
    },
    {
      name: 'clean-slate',
      type: 'registry:style',
      title: 'Clean Slate',
      description: 'A theme based on the Clean Slate color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Inter, sans-serif',
          'font-mono': 'JetBrains Mono, monospace',
          'font-serif': 'Merriweather, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '210 40% 98%',
          foreground: '217 33% 17%',
          card: '0 0% 100%',
          'card-foreground': '217 33% 17%',
          popover: '0 0% 100%',
          'popover-foreground': '217 33% 17%',
          primary: '239 84% 67%',
          'primary-foreground': '0 0% 100%',
          secondary: '220 13% 91%',
          'secondary-foreground': '217 19% 27%',
          muted: '220 14% 96%',
          'muted-foreground': '220 9% 46%',
          accent: '226 100% 94%',
          'accent-foreground': '217 19% 27%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '216 12% 84%',
          input: '216 12% 84%',
          ring: '239 84% 67%',
          'chart-1': '239 84% 67%',
          'chart-2': '243 75% 59%',
          'chart-3': '245 58% 51%',
          'chart-4': '244 54% 41%',
          'chart-5': '242 47% 34%',
          radius: '0.5rem',
          sidebar: '220 14% 96%',
          'sidebar-foreground': '217 33% 17%',
          'sidebar-primary': '239 84% 67%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '226 100% 94%',
          'sidebar-accent-foreground': '217 19% 27%',
          'sidebar-border': '216 12% 84%',
          'sidebar-ring': '239 84% 67%',
          'font-sans': 'Inter, sans-serif',
          'font-serif': 'Merriweather, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '8px',
          'shadow-spread': '-1px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
          shadow: '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 2px 4px -2px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 4px 6px -2px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 8px 10px -2px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '222 47% 11%',
          foreground: '214 32% 91%',
          card: '217 33% 17%',
          'card-foreground': '214 32% 91%',
          popover: '217 33% 17%',
          'popover-foreground': '214 32% 91%',
          primary: '234 89% 74%',
          'primary-foreground': '222 47% 11%',
          secondary: '218 23% 23%',
          'secondary-foreground': '216 12% 84%',
          muted: '217 41% 14%',
          'muted-foreground': '218 11% 65%',
          accent: '217 19% 27%',
          'accent-foreground': '216 12% 84%',
          destructive: '0 84% 60%',
          'destructive-foreground': '222 47% 11%',
          border: '215 14% 34%',
          input: '215 14% 34%',
          ring: '234 89% 74%',
          'chart-1': '234 89% 74%',
          'chart-2': '239 84% 67%',
          'chart-3': '243 75% 59%',
          'chart-4': '245 58% 51%',
          'chart-5': '244 54% 41%',
          radius: '0.5rem',
          sidebar: '217 33% 17%',
          'sidebar-foreground': '214 32% 91%',
          'sidebar-primary': '234 89% 74%',
          'sidebar-primary-foreground': '222 47% 11%',
          'sidebar-accent': '217 19% 27%',
          'sidebar-accent-foreground': '216 12% 84%',
          'sidebar-border': '215 14% 34%',
          'sidebar-ring': '234 89% 74%',
          'font-sans': 'Inter, sans-serif',
          'font-serif': 'Merriweather, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '8px',
          'shadow-spread': '-1px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
          shadow: '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 2px 4px -2px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 4px 6px -2px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 8px 10px -2px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'caffeine',
      type: 'registry:style',
      title: 'Caffeine',
      description: 'A theme based on the Caffeine color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans':
            "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
          'font-mono':
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '180 0% 98%',
          foreground: '0 0% 13%',
          card: '0 0% 99%',
          'card-foreground': '0 0% 13%',
          popover: '0 0% 99%',
          'popover-foreground': '0 0% 13%',
          primary: '17 22% 32%',
          'primary-foreground': '0 0% 100%',
          secondary: '34 100% 85%',
          'secondary-foreground': '16 50% 23%',
          muted: '240 0% 94%',
          'muted-foreground': '180 0% 39%',
          accent: '0 0% 91%',
          'accent-foreground': '0 0% 13%',
          destructive: '10 78% 54%',
          'destructive-foreground': '0 0% 100%',
          border: '180 0% 85%',
          input: '180 0% 85%',
          ring: '17 22% 32%',
          'chart-1': '17 22% 32%',
          'chart-2': '34 100% 85%',
          'chart-3': '0 0% 91%',
          'chart-4': '35 100% 88%',
          'chart-5': '16 24% 32%',
          radius: '0.5rem',
          sidebar: '0 0% 98%',
          'sidebar-foreground': '180 0% 15%',
          'sidebar-primary': '120 0% 20%',
          'sidebar-primary-foreground': '0 0% 98%',
          'sidebar-accent': '240 0% 97%',
          'sidebar-accent-foreground': '120 0% 20%',
          'sidebar-border': '0 0% 92%',
          'sidebar-ring': '180 0% 71%',
          'font-sans':
            "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono':
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '0 0% 7%',
          foreground: '150 0% 93%',
          card: '0 0% 10%',
          'card-foreground': '150 0% 93%',
          popover: '0 0% 10%',
          'popover-foreground': '150 0% 93%',
          primary: '30 100% 88%',
          'primary-foreground': '183 54% 7%',
          secondary: '28 18% 19%',
          'secondary-foreground': '30 100% 88%',
          muted: '300 0% 13%',
          'muted-foreground': '60 0% 71%',
          accent: '180 0% 16%',
          'accent-foreground': '150 0% 93%',
          destructive: '10 78% 54%',
          'destructive-foreground': '0 0% 100%',
          border: '45 14% 11%',
          input: '60 0% 28%',
          ring: '30 100% 88%',
          'chart-1': '30 100% 88%',
          'chart-2': '28 18% 19%',
          'chart-3': '180 0% 16%',
          'chart-4': '30 18% 22%',
          'chart-5': '30 100% 88%',
          radius: '0.5rem',
          sidebar: '240 6% 10%',
          'sidebar-foreground': '240 5% 96%',
          'sidebar-primary': '224 76% 48%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '240 4% 16%',
          'sidebar-accent-foreground': '240 5% 96%',
          'sidebar-border': '240 4% 16%',
          'sidebar-ring': '240 5% 84%',
          'font-sans':
            "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono':
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'ocean-breeze',
      type: 'registry:style',
      title: 'Ocean Breeze',
      description: 'A theme based on the Ocean Breeze color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'DM Sans, sans-serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'font-serif': 'Lora, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '208 100% 97%',
          foreground: '217 19% 27%',
          card: '0 0% 100%',
          'card-foreground': '217 19% 27%',
          popover: '0 0% 100%',
          'popover-foreground': '217 19% 27%',
          primary: '142 71% 45%',
          'primary-foreground': '0 0% 100%',
          secondary: '204 94% 94%',
          'secondary-foreground': '215 14% 34%',
          muted: '220 14% 96%',
          'muted-foreground': '220 9% 46%',
          accent: '149 80% 90%',
          'accent-foreground': '217 19% 27%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '220 13% 91%',
          input: '220 13% 91%',
          ring: '142 71% 45%',
          'chart-1': '142 71% 45%',
          'chart-2': '160 84% 39%',
          'chart-3': '161 93% 30%',
          'chart-4': '163 93% 24%',
          'chart-5': '163 88% 20%',
          radius: '0.5rem',
          sidebar: '204 94% 94%',
          'sidebar-foreground': '217 19% 27%',
          'sidebar-primary': '142 71% 45%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '149 80% 90%',
          'sidebar-accent-foreground': '217 19% 27%',
          'sidebar-border': '220 13% 91%',
          'sidebar-ring': '142 71% 45%',
          'font-sans': 'DM Sans, sans-serif',
          'font-serif': 'Lora, serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '8px',
          'shadow-spread': '-1px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
          shadow: '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 2px 4px -2px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 4px 6px -2px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 8px 10px -2px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '222 47% 11%',
          foreground: '216 12% 84%',
          card: '217 33% 17%',
          'card-foreground': '216 12% 84%',
          popover: '217 33% 17%',
          'popover-foreground': '216 12% 84%',
          primary: '158 64% 52%',
          'primary-foreground': '222 47% 11%',
          secondary: '218 23% 23%',
          'secondary-foreground': '240 5% 65%',
          muted: '217 30% 14%',
          'muted-foreground': '220 9% 46%',
          accent: '217 19% 27%',
          'accent-foreground': '240 5% 65%',
          destructive: '0 84% 60%',
          'destructive-foreground': '222 47% 11%',
          border: '215 14% 34%',
          input: '215 14% 34%',
          ring: '158 64% 52%',
          'chart-1': '158 64% 52%',
          'chart-2': '172 66% 50%',
          'chart-3': '142 71% 45%',
          'chart-4': '160 84% 39%',
          'chart-5': '161 93% 30%',
          radius: '0.5rem',
          sidebar: '217 33% 17%',
          'sidebar-foreground': '216 12% 84%',
          'sidebar-primary': '158 64% 52%',
          'sidebar-primary-foreground': '222 47% 11%',
          'sidebar-accent': '217 19% 27%',
          'sidebar-accent-foreground': '240 5% 65%',
          'sidebar-border': '215 14% 34%',
          'sidebar-ring': '158 64% 52%',
          'font-sans': 'DM Sans, sans-serif',
          'font-serif': 'Lora, serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '8px',
          'shadow-spread': '-1px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '4px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0px 4px 8px -1px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
          shadow: '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 1px 2px -2px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 2px 4px -2px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 4px 6px -2px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.10), 0px 8px 10px -2px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0px 4px 8px -1px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'retro-arcade',
      type: 'registry:style',
      title: 'Retro Arcade',
      description: 'A theme based on the Retro Arcade color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Outfit, sans-serif',
          'font-mono': 'Space Mono, monospace',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          radius: '0.25rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '44 87% 94%',
          foreground: '192 81% 14%',
          card: '46 42% 88%',
          'card-foreground': '192 81% 14%',
          popover: '46 42% 88%',
          'popover-foreground': '192 81% 14%',
          primary: '331 64% 52%',
          'primary-foreground': '0 0% 100%',
          secondary: '175 59% 40%',
          'secondary-foreground': '0 0% 100%',
          muted: '180 7% 60%',
          'muted-foreground': '192 81% 14%',
          accent: '18 80% 44%',
          'accent-foreground': '0 0% 100%',
          destructive: '1 71% 52%',
          'destructive-foreground': '0 0% 100%',
          border: '186 8% 55%',
          input: '186 8% 55%',
          ring: '331 64% 52%',
          'chart-1': '205 69% 49%',
          'chart-2': '175 59% 40%',
          'chart-3': '331 64% 52%',
          'chart-4': '18 80% 44%',
          'chart-5': '1 71% 52%',
          radius: '0.25rem',
          sidebar: '44 87% 94%',
          'sidebar-foreground': '192 81% 14%',
          'sidebar-primary': '331 64% 52%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '175 59% 40%',
          'sidebar-accent-foreground': '0 0% 100%',
          'sidebar-border': '186 8% 55%',
          'sidebar-ring': '331 64% 52%',
          'font-sans': 'Outfit, sans-serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono': 'Space Mono, monospace',
          'shadow-color': '196 83% 10%',
          'shadow-opacity': '0.15',
          'shadow-blur': '4px',
          'shadow-spread': '0px',
          'shadow-offset-x': '2px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '2px 2px 4px 0px hsl(196 83% 10% / 0.07)',
          'shadow-xs': '2px 2px 4px 0px hsl(196 83% 10% / 0.07)',
          'shadow-sm': '2px 2px 4px 0px hsl(196 83% 10% / 0.15), 2px 1px 2px -1px hsl(196 83% 10% / 0.15)',
          shadow: '2px 2px 4px 0px hsl(196 83% 10% / 0.15), 2px 1px 2px -1px hsl(196 83% 10% / 0.15)',
          'shadow-md': '2px 2px 4px 0px hsl(196 83% 10% / 0.15), 2px 2px 4px -1px hsl(196 83% 10% / 0.15)',
          'shadow-lg': '2px 2px 4px 0px hsl(196 83% 10% / 0.15), 2px 4px 6px -1px hsl(196 83% 10% / 0.15)',
          'shadow-xl': '2px 2px 4px 0px hsl(196 83% 10% / 0.15), 2px 8px 10px -1px hsl(196 83% 10% / 0.15)',
          'shadow-2xl': '2px 2px 4px 0px hsl(196 83% 10% / 0.38)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '192 100% 11%',
          foreground: '180 7% 60%',
          card: '192 81% 14%',
          'card-foreground': '180 7% 60%',
          popover: '192 81% 14%',
          'popover-foreground': '180 7% 60%',
          primary: '331 64% 52%',
          'primary-foreground': '0 0% 100%',
          secondary: '175 59% 40%',
          'secondary-foreground': '0 0% 100%',
          muted: '194 14% 40%',
          'muted-foreground': '180 7% 60%',
          accent: '18 80% 44%',
          'accent-foreground': '0 0% 100%',
          destructive: '1 71% 52%',
          'destructive-foreground': '0 0% 100%',
          border: '194 14% 40%',
          input: '194 14% 40%',
          ring: '331 64% 52%',
          'chart-1': '205 69% 49%',
          'chart-2': '175 59% 40%',
          'chart-3': '331 64% 52%',
          'chart-4': '18 80% 44%',
          'chart-5': '1 71% 52%',
          radius: '0.25rem',
          sidebar: '192 100% 11%',
          'sidebar-foreground': '180 7% 60%',
          'sidebar-primary': '331 64% 52%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '175 59% 40%',
          'sidebar-accent-foreground': '0 0% 100%',
          'sidebar-border': '194 14% 40%',
          'sidebar-ring': '331 64% 52%',
          'font-sans': 'Outfit, sans-serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono': 'Space Mono, monospace',
          'shadow-color': '196 83% 10%',
          'shadow-opacity': '0.15',
          'shadow-blur': '4px',
          'shadow-spread': '0px',
          'shadow-offset-x': '2px',
          'shadow-offset-y': '2px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '2px 2px 4px 0px hsl(196 83% 10% / 0.07)',
          'shadow-xs': '2px 2px 4px 0px hsl(196 83% 10% / 0.07)',
          'shadow-sm': '2px 2px 4px 0px hsl(196 83% 10% / 0.15), 2px 1px 2px -1px hsl(196 83% 10% / 0.15)',
          shadow: '2px 2px 4px 0px hsl(196 83% 10% / 0.15), 2px 1px 2px -1px hsl(196 83% 10% / 0.15)',
          'shadow-md': '2px 2px 4px 0px hsl(196 83% 10% / 0.15), 2px 2px 4px -1px hsl(196 83% 10% / 0.15)',
          'shadow-lg': '2px 2px 4px 0px hsl(196 83% 10% / 0.15), 2px 4px 6px -1px hsl(196 83% 10% / 0.15)',
          'shadow-xl': '2px 2px 4px 0px hsl(196 83% 10% / 0.15), 2px 8px 10px -1px hsl(196 83% 10% / 0.15)',
          'shadow-2xl': '2px 2px 4px 0px hsl(196 83% 10% / 0.38)',
        },
      },
    },
    {
      name: 'midnight-bloom',
      type: 'registry:style',
      title: 'Midnight Bloom',
      description: 'A theme based on the Midnight Bloom color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Montserrat, sans-serif',
          'font-mono': 'Source Code Pro, monospace',
          'font-serif': 'Playfair Display, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '180 0% 98%',
          foreground: '0 0% 20%',
          card: '0 0% 100%',
          'card-foreground': '0 0% 20%',
          popover: '0 0% 100%',
          'popover-foreground': '0 0% 20%',
          primary: '247 74% 63%',
          'primary-foreground': '0 0% 100%',
          secondary: '210 76% 79%',
          'secondary-foreground': '0 0% 20%',
          muted: '45 16% 75%',
          'muted-foreground': '180 0% 43%',
          accent: '72 18% 49%',
          'accent-foreground': '0 0% 100%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '180 0% 83%',
          input: '180 0% 83%',
          ring: '247 74% 63%',
          'chart-1': '247 74% 63%',
          'chart-2': '282 44% 47%',
          'chart-3': '275 100% 25%',
          'chart-4': '219 79% 66%',
          'chart-5': '207 44% 49%',
          radius: '0.5rem',
          sidebar: '180 0% 98%',
          'sidebar-foreground': '0 0% 20%',
          'sidebar-primary': '247 74% 63%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '72 18% 49%',
          'sidebar-accent-foreground': '0 0% 100%',
          'sidebar-border': '180 0% 83%',
          'sidebar-ring': '247 74% 63%',
          'font-sans': 'Montserrat, sans-serif',
          'font-serif': 'Playfair Display, serif',
          'font-mono': 'Source Code Pro, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '10px',
          'shadow-spread': '-2px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '5px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 5px 10px -2px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0px 5px 10px -2px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 1px 2px -3px hsl(0 0% 0% / 0.10)',
          shadow: '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 1px 2px -3px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 2px 4px -3px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 4px 6px -3px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 8px 10px -3px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0px 5px 10px -2px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '220 15% 12%',
          foreground: '120 0% 90%',
          card: '197 7% 20%',
          'card-foreground': '120 0% 90%',
          popover: '197 7% 20%',
          'popover-foreground': '120 0% 90%',
          primary: '247 74% 63%',
          'primary-foreground': '0 0% 100%',
          secondary: '275 100% 25%',
          'secondary-foreground': '120 0% 90%',
          muted: '120 0% 27%',
          'muted-foreground': '120 0% 64%',
          accent: '219 79% 66%',
          'accent-foreground': '120 0% 90%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '120 0% 27%',
          input: '120 0% 27%',
          ring: '247 74% 63%',
          'chart-1': '247 74% 63%',
          'chart-2': '282 44% 47%',
          'chart-3': '275 100% 25%',
          'chart-4': '219 79% 66%',
          'chart-5': '207 44% 49%',
          radius: '0.5rem',
          sidebar: '220 15% 12%',
          'sidebar-foreground': '120 0% 90%',
          'sidebar-primary': '247 74% 63%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '219 79% 66%',
          'sidebar-accent-foreground': '120 0% 90%',
          'sidebar-border': '120 0% 27%',
          'sidebar-ring': '247 74% 63%',
          'font-sans': 'Montserrat, sans-serif',
          'font-serif': 'Playfair Display, serif',
          'font-mono': 'Source Code Pro, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '10px',
          'shadow-spread': '-2px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '5px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 5px 10px -2px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0px 5px 10px -2px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 1px 2px -3px hsl(0 0% 0% / 0.10)',
          shadow: '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 1px 2px -3px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 2px 4px -3px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 4px 6px -3px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0px 5px 10px -2px hsl(0 0% 0% / 0.10), 0px 8px 10px -3px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0px 5px 10px -2px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'candyland',
      type: 'registry:style',
      title: 'Candyland',
      description: 'A theme based on the Candyland color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Poppins, sans-serif',
          'font-mono': 'Roboto Mono, monospace',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '200 23% 97%',
          foreground: '0 0% 20%',
          card: '0 0% 100%',
          'card-foreground': '0 0% 20%',
          popover: '0 0% 100%',
          'popover-foreground': '0 0% 20%',
          primary: '350 100% 88%',
          'primary-foreground': '0 0% 0%',
          secondary: '197 71% 73%',
          'secondary-foreground': '0 0% 0%',
          muted: '50 27% 82%',
          'muted-foreground': '180 0% 43%',
          accent: '60 100% 50%',
          'accent-foreground': '0 0% 0%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '180 0% 83%',
          input: '180 0% 83%',
          ring: '350 100% 88%',
          'chart-1': '350 100% 88%',
          'chart-2': '197 71% 73%',
          'chart-3': '60 100% 50%',
          'chart-4': '330 100% 80%',
          'chart-5': '120 60% 50%',
          radius: '0.5rem',
          sidebar: '200 23% 97%',
          'sidebar-foreground': '0 0% 20%',
          'sidebar-primary': '350 100% 88%',
          'sidebar-primary-foreground': '0 0% 0%',
          'sidebar-accent': '60 100% 50%',
          'sidebar-accent-foreground': '0 0% 0%',
          'sidebar-border': '180 0% 83%',
          'sidebar-ring': '350 100% 88%',
          'font-sans': 'Poppins, sans-serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono': 'Roboto Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '220 15% 12%',
          foreground: '120 0% 90%',
          card: '197 7% 20%',
          'card-foreground': '120 0% 90%',
          popover: '197 7% 20%',
          'popover-foreground': '120 0% 90%',
          primary: '330 100% 80%',
          'primary-foreground': '0 0% 0%',
          secondary: '120 60% 50%',
          'secondary-foreground': '0 0% 0%',
          muted: '120 0% 27%',
          'muted-foreground': '120 0% 64%',
          accent: '197 71% 73%',
          'accent-foreground': '0 0% 0%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '120 0% 27%',
          input: '120 0% 27%',
          ring: '330 100% 80%',
          'chart-1': '330 100% 80%',
          'chart-2': '120 60% 50%',
          'chart-3': '197 71% 73%',
          'chart-4': '60 100% 50%',
          'chart-5': '48 100% 50%',
          radius: '0.5rem',
          sidebar: '220 15% 12%',
          'sidebar-foreground': '120 0% 90%',
          'sidebar-primary': '330 100% 80%',
          'sidebar-primary-foreground': '0 0% 0%',
          'sidebar-accent': '197 71% 73%',
          'sidebar-accent-foreground': '0 0% 0%',
          'sidebar-border': '120 0% 27%',
          'sidebar-ring': '330 100% 80%',
          'font-sans': 'Poppins, sans-serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono': 'Roboto Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'northern-lights',
      type: 'registry:style',
      title: 'Northern Lights',
      description: 'A theme based on the Northern Lights color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Plus Jakarta Sans, sans-serif',
          'font-mono': 'JetBrains Mono, monospace',
          'font-serif': 'Source Serif 4, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '240 9% 98%',
          foreground: '0 0% 20%',
          card: '0 0% 100%',
          'card-foreground': '0 0% 20%',
          popover: '0 0% 100%',
          'popover-foreground': '0 0% 20%',
          primary: '140 53% 43%',
          'primary-foreground': '0 0% 100%',
          secondary: '219 79% 66%',
          'secondary-foreground': '0 0% 100%',
          muted: '50 27% 82%',
          'muted-foreground': '180 0% 43%',
          accent: '190 81% 67%',
          'accent-foreground': '0 0% 20%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '180 0% 83%',
          input: '180 0% 83%',
          ring: '140 53% 43%',
          'chart-1': '140 53% 43%',
          'chart-2': '219 79% 66%',
          'chart-3': '190 81% 67%',
          'chart-4': '207 44% 49%',
          'chart-5': '139 70% 35%',
          radius: '0.5rem',
          sidebar: '240 9% 98%',
          'sidebar-foreground': '0 0% 20%',
          'sidebar-primary': '140 53% 43%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '190 81% 67%',
          'sidebar-accent-foreground': '0 0% 20%',
          'sidebar-border': '180 0% 83%',
          'sidebar-ring': '140 53% 43%',
          'font-sans': 'Plus Jakarta Sans, sans-serif',
          'font-serif': 'Source Serif 4, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '220 15% 12%',
          foreground: '120 0% 90%',
          card: '197 7% 20%',
          'card-foreground': '120 0% 90%',
          popover: '197 7% 20%',
          'popover-foreground': '120 0% 90%',
          primary: '140 53% 43%',
          'primary-foreground': '0 0% 100%',
          secondary: '207 44% 49%',
          'secondary-foreground': '120 0% 90%',
          muted: '120 0% 27%',
          'muted-foreground': '120 0% 64%',
          accent: '219 79% 66%',
          'accent-foreground': '120 0% 90%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '120 0% 27%',
          input: '120 0% 27%',
          ring: '140 53% 43%',
          'chart-1': '140 53% 43%',
          'chart-2': '207 44% 49%',
          'chart-3': '219 79% 66%',
          'chart-4': '190 81% 67%',
          'chart-5': '139 70% 35%',
          radius: '0.5rem',
          sidebar: '220 15% 12%',
          'sidebar-foreground': '120 0% 90%',
          'sidebar-primary': '140 53% 43%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '219 79% 66%',
          'sidebar-accent-foreground': '120 0% 90%',
          'sidebar-border': '120 0% 27%',
          'sidebar-ring': '140 53% 43%',
          'font-sans': 'Plus Jakarta Sans, sans-serif',
          'font-serif': 'Source Serif 4, serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'vintage-paper',
      type: 'registry:style',
      title: 'Vintage Paper',
      description: 'A theme based on the Vintage Paper color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Libre Baskerville, serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'font-serif': 'Lora, serif',
          radius: '0.25rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '44 43% 93%',
          foreground: '29 17% 25%',
          card: '42 100% 98%',
          'card-foreground': '29 17% 25%',
          popover: '42 100% 98%',
          'popover-foreground': '29 17% 25%',
          primary: '30 34% 49%',
          'primary-foreground': '0 0% 100%',
          secondary: '41 35% 83%',
          'secondary-foreground': '29 19% 30%',
          muted: '39 35% 89%',
          'muted-foreground': '32 18% 41%',
          accent: '43 33% 75%',
          'accent-foreground': '29 17% 25%',
          destructive: '10 55% 46%',
          'destructive-foreground': '0 0% 100%',
          border: '40 31% 79%',
          input: '40 31% 79%',
          ring: '30 34% 49%',
          'chart-1': '30 34% 49%',
          'chart-2': '31 30% 43%',
          'chart-3': '34 33% 34%',
          'chart-4': '29 31% 57%',
          'chart-5': '30 34% 63%',
          radius: '0.25rem',
          sidebar: '39 35% 89%',
          'sidebar-foreground': '29 17% 25%',
          'sidebar-primary': '30 34% 49%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '43 33% 75%',
          'sidebar-accent-foreground': '29 17% 25%',
          'sidebar-border': '40 31% 79%',
          'sidebar-ring': '30 34% 49%',
          'font-sans': 'Libre Baskerville, serif',
          'font-serif': 'Lora, serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'shadow-color': '28 13% 20%',
          'shadow-opacity': '0.12',
          'shadow-blur': '5px',
          'shadow-spread': '0px',
          'shadow-offset-x': '2px',
          'shadow-offset-y': '3px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '2px 3px 5px 0px hsl(28 13% 20% / 0.06)',
          'shadow-xs': '2px 3px 5px 0px hsl(28 13% 20% / 0.06)',
          'shadow-sm': '2px 3px 5px 0px hsl(28 13% 20% / 0.12), 2px 1px 2px -1px hsl(28 13% 20% / 0.12)',
          shadow: '2px 3px 5px 0px hsl(28 13% 20% / 0.12), 2px 1px 2px -1px hsl(28 13% 20% / 0.12)',
          'shadow-md': '2px 3px 5px 0px hsl(28 13% 20% / 0.12), 2px 2px 4px -1px hsl(28 13% 20% / 0.12)',
          'shadow-lg': '2px 3px 5px 0px hsl(28 13% 20% / 0.12), 2px 4px 6px -1px hsl(28 13% 20% / 0.12)',
          'shadow-xl': '2px 3px 5px 0px hsl(28 13% 20% / 0.12), 2px 8px 10px -1px hsl(28 13% 20% / 0.12)',
          'shadow-2xl': '2px 3px 5px 0px hsl(28 13% 20% / 0.30)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '25 15% 15%',
          foreground: '39 35% 89%',
          card: '26 14% 20%',
          'card-foreground': '39 35% 89%',
          popover: '26 14% 20%',
          'popover-foreground': '39 35% 89%',
          primary: '30 34% 63%',
          'primary-foreground': '25 15% 15%',
          secondary: '25 13% 26%',
          'secondary-foreground': '39 35% 89%',
          muted: '27 13% 17%',
          'muted-foreground': '38 18% 72%',
          accent: '24 18% 30%',
          'accent-foreground': '39 35% 89%',
          destructive: '10 55% 46%',
          'destructive-foreground': '0 0% 100%',
          border: '25 13% 26%',
          input: '25 13% 26%',
          ring: '30 34% 63%',
          'chart-1': '30 34% 63%',
          'chart-2': '29 31% 57%',
          'chart-3': '30 34% 49%',
          'chart-4': '31 30% 43%',
          'chart-5': '34 33% 34%',
          radius: '0.25rem',
          sidebar: '25 15% 15%',
          'sidebar-foreground': '39 35% 89%',
          'sidebar-primary': '30 34% 63%',
          'sidebar-primary-foreground': '25 15% 15%',
          'sidebar-accent': '24 18% 30%',
          'sidebar-accent-foreground': '39 35% 89%',
          'sidebar-border': '25 13% 26%',
          'sidebar-ring': '30 34% 63%',
          'font-sans': 'Libre Baskerville, serif',
          'font-serif': 'Lora, serif',
          'font-mono': 'IBM Plex Mono, monospace',
          'shadow-color': '28 13% 20%',
          'shadow-opacity': '0.12',
          'shadow-blur': '5px',
          'shadow-spread': '0px',
          'shadow-offset-x': '2px',
          'shadow-offset-y': '3px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '2px 3px 5px 0px hsl(28 13% 20% / 0.06)',
          'shadow-xs': '2px 3px 5px 0px hsl(28 13% 20% / 0.06)',
          'shadow-sm': '2px 3px 5px 0px hsl(28 13% 20% / 0.12), 2px 1px 2px -1px hsl(28 13% 20% / 0.12)',
          shadow: '2px 3px 5px 0px hsl(28 13% 20% / 0.12), 2px 1px 2px -1px hsl(28 13% 20% / 0.12)',
          'shadow-md': '2px 3px 5px 0px hsl(28 13% 20% / 0.12), 2px 2px 4px -1px hsl(28 13% 20% / 0.12)',
          'shadow-lg': '2px 3px 5px 0px hsl(28 13% 20% / 0.12), 2px 4px 6px -1px hsl(28 13% 20% / 0.12)',
          'shadow-xl': '2px 3px 5px 0px hsl(28 13% 20% / 0.12), 2px 8px 10px -1px hsl(28 13% 20% / 0.12)',
          'shadow-2xl': '2px 3px 5px 0px hsl(28 13% 20% / 0.30)',
        },
      },
    },
    {
      name: 'sunset-horizon',
      type: 'registry:style',
      title: 'Sunset Horizon',
      description: 'A theme based on the Sunset Horizon color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Montserrat, sans-serif',
          'font-mono': 'Ubuntu Mono, monospace',
          'font-serif': 'Merriweather, serif',
          radius: '0.625rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '24 100% 98%',
          foreground: '347 8% 22%',
          card: '0 0% 100%',
          'card-foreground': '347 8% 22%',
          popover: '0 0% 100%',
          'popover-foreground': '347 8% 22%',
          primary: '12 100% 69%',
          'primary-foreground': '0 0% 100%',
          secondary: '9 100% 96%',
          'secondary-foreground': '10 47% 48%',
          muted: '15 100% 96%',
          'muted-foreground': '25 5% 45%',
          accent: '26 99% 74%',
          'accent-foreground': '347 8% 22%',
          destructive: '355 78% 56%',
          'destructive-foreground': '0 0% 100%',
          border: '15 100% 92%',
          input: '15 100% 92%',
          ring: '12 100% 69%',
          'chart-1': '12 100% 69%',
          'chart-2': '26 99% 74%',
          'chart-3': '24 100% 83%',
          'chart-4': '16 100% 78%',
          'chart-5': '10 55% 57%',
          radius: '0.625rem',
          sidebar: '15 100% 96%',
          'sidebar-foreground': '347 8% 22%',
          'sidebar-primary': '12 100% 69%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '26 99% 74%',
          'sidebar-accent-foreground': '347 8% 22%',
          'sidebar-border': '15 100% 92%',
          'sidebar-ring': '12 100% 69%',
          'font-sans': 'Montserrat, sans-serif',
          'font-serif': 'Merriweather, serif',
          'font-mono': 'Ubuntu Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.09',
          'shadow-blur': '12px',
          'shadow-spread': '-3px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '6px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 6px 12px -3px hsl(0 0% 0% / 0.04)',
          'shadow-xs': '0px 6px 12px -3px hsl(0 0% 0% / 0.04)',
          'shadow-sm': '0px 6px 12px -3px hsl(0 0% 0% / 0.09), 0px 1px 2px -4px hsl(0 0% 0% / 0.09)',
          shadow: '0px 6px 12px -3px hsl(0 0% 0% / 0.09), 0px 1px 2px -4px hsl(0 0% 0% / 0.09)',
          'shadow-md': '0px 6px 12px -3px hsl(0 0% 0% / 0.09), 0px 2px 4px -4px hsl(0 0% 0% / 0.09)',
          'shadow-lg': '0px 6px 12px -3px hsl(0 0% 0% / 0.09), 0px 4px 6px -4px hsl(0 0% 0% / 0.09)',
          'shadow-xl': '0px 6px 12px -3px hsl(0 0% 0% / 0.09), 0px 8px 10px -4px hsl(0 0% 0% / 0.09)',
          'shadow-2xl': '0px 6px 12px -3px hsl(0 0% 0% / 0.22)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '336 14% 15%',
          foreground: '21 35% 92%',
          card: '324 10% 20%',
          'card-foreground': '21 35% 92%',
          popover: '324 10% 20%',
          'popover-foreground': '21 35% 92%',
          primary: '12 100% 69%',
          'primary-foreground': '0 0% 100%',
          secondary: '325 9% 25%',
          'secondary-foreground': '21 35% 92%',
          muted: '327 10% 17%',
          'muted-foreground': '22 25% 79%',
          accent: '26 99% 74%',
          'accent-foreground': '336 14% 15%',
          destructive: '355 78% 56%',
          'destructive-foreground': '0 0% 100%',
          border: '325 9% 25%',
          input: '325 9% 25%',
          ring: '12 100% 69%',
          'chart-1': '12 100% 69%',
          'chart-2': '26 99% 74%',
          'chart-3': '24 100% 83%',
          'chart-4': '16 100% 78%',
          'chart-5': '10 55% 57%',
          radius: '0.625rem',
          sidebar: '336 14% 15%',
          'sidebar-foreground': '21 35% 92%',
          'sidebar-primary': '12 100% 69%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '26 99% 74%',
          'sidebar-accent-foreground': '336 14% 15%',
          'sidebar-border': '325 9% 25%',
          'sidebar-ring': '12 100% 69%',
          'font-sans': 'Montserrat, sans-serif',
          'font-serif': 'Merriweather, serif',
          'font-mono': 'Ubuntu Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.09',
          'shadow-blur': '12px',
          'shadow-spread': '-3px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '6px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 6px 12px -3px hsl(0 0% 0% / 0.04)',
          'shadow-xs': '0px 6px 12px -3px hsl(0 0% 0% / 0.04)',
          'shadow-sm': '0px 6px 12px -3px hsl(0 0% 0% / 0.09), 0px 1px 2px -4px hsl(0 0% 0% / 0.09)',
          shadow: '0px 6px 12px -3px hsl(0 0% 0% / 0.09), 0px 1px 2px -4px hsl(0 0% 0% / 0.09)',
          'shadow-md': '0px 6px 12px -3px hsl(0 0% 0% / 0.09), 0px 2px 4px -4px hsl(0 0% 0% / 0.09)',
          'shadow-lg': '0px 6px 12px -3px hsl(0 0% 0% / 0.09), 0px 4px 6px -4px hsl(0 0% 0% / 0.09)',
          'shadow-xl': '0px 6px 12px -3px hsl(0 0% 0% / 0.09), 0px 8px 10px -4px hsl(0 0% 0% / 0.09)',
          'shadow-2xl': '0px 6px 12px -3px hsl(0 0% 0% / 0.22)',
        },
      },
    },
    {
      name: 'starry-night',
      type: 'registry:style',
      title: 'Starry Night',
      description: 'A theme based on the Starry Night color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Libre Baskerville, serif',
          'font-mono':
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '216 33% 97%',
          foreground: '224 37% 16%',
          card: '212 37% 92%',
          'card-foreground': '224 37% 16%',
          popover: '50 100% 95%',
          'popover-foreground': '224 37% 16%',
          primary: '221 47% 43%',
          'primary-foreground': '50 100% 95%',
          secondary: '39 89% 71%',
          'secondary-foreground': '224 37% 16%',
          muted: '60 10% 89%',
          'muted-foreground': '221 47% 43%',
          accent: '202 40% 59%',
          'accent-foreground': '50 100% 95%',
          destructive: '293 22% 15%',
          'destructive-foreground': '50 100% 95%',
          border: '212 12% 72%',
          input: '202 40% 59%',
          ring: '39 89% 71%',
          'chart-1': '221 47% 43%',
          'chart-2': '39 89% 71%',
          'chart-3': '202 40% 59%',
          'chart-4': '212 12% 72%',
          'chart-5': '293 22% 15%',
          radius: '0.5rem',
          sidebar: '212 37% 92%',
          'sidebar-foreground': '224 37% 16%',
          'sidebar-primary': '221 47% 43%',
          'sidebar-primary-foreground': '50 100% 95%',
          'sidebar-accent': '39 89% 71%',
          'sidebar-accent-foreground': '224 37% 16%',
          'sidebar-border': '212 12% 72%',
          'sidebar-ring': '39 89% 71%',
          'font-sans': 'Libre Baskerville, serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono':
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '230 20% 12%',
          foreground: '222 35% 93%',
          card: '237 25% 18%',
          'card-foreground': '222 35% 93%',
          popover: '237 25% 18%',
          'popover-foreground': '48 100% 70%',
          primary: '221 47% 43%',
          'primary-foreground': '48 100% 70%',
          secondary: '48 100% 70%',
          'secondary-foreground': '237 25% 18%',
          muted: '237 24% 15%',
          'muted-foreground': '218 17% 55%',
          accent: '220 63% 84%',
          'accent-foreground': '230 20% 12%',
          destructive: '336 37% 46%',
          'destructive-foreground': '48 100% 70%',
          border: '236 16% 21%',
          input: '221 47% 43%',
          ring: '48 100% 70%',
          'chart-1': '221 47% 43%',
          'chart-2': '48 100% 70%',
          'chart-3': '202 40% 59%',
          'chart-4': '218 17% 55%',
          'chart-5': '336 37% 46%',
          radius: '0.5rem',
          sidebar: '237 25% 18%',
          'sidebar-foreground': '222 35% 93%',
          'sidebar-primary': '221 47% 43%',
          'sidebar-primary-foreground': '48 100% 70%',
          'sidebar-accent': '48 100% 70%',
          'sidebar-accent-foreground': '237 25% 18%',
          'sidebar-border': '236 16% 21%',
          'sidebar-ring': '48 100% 70%',
          'font-sans': 'Libre Baskerville, serif',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono':
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'claude',
      type: 'registry:style',
      title: 'Claude',
      description: 'A theme based on the Claude color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans':
            "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
          'font-mono':
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '48 33% 97%',
          foreground: '48 20% 20%',
          card: '48 33% 97%',
          'card-foreground': '60 3% 8%',
          popover: '0 0% 100%',
          'popover-foreground': '51 19% 13%',
          primary: '15 56% 52%',
          'primary-foreground': '0 0% 100%',
          secondary: '46 23% 89%',
          'secondary-foreground': '51 8% 30%',
          muted: '44 29% 90%',
          'muted-foreground': '50 2% 50%',
          accent: '46 23% 89%',
          'accent-foreground': '51 19% 13%',
          destructive: '60 3% 8%',
          'destructive-foreground': '0 0% 100%',
          border: '50 8% 84%',
          input: '51 8% 68%',
          ring: '15 56% 52%',
          'chart-1': '18 57% 44%',
          'chart-2': '251 85% 75%',
          'chart-3': '46 28% 82%',
          'chart-4': '257 49% 88%',
          'chart-5': '18 60% 44%',
          radius: '0.5rem',
          sidebar: '51 26% 95%',
          'sidebar-foreground': '60 3% 23%',
          'sidebar-primary': '15 56% 52%',
          'sidebar-primary-foreground': '0 0% 98%',
          'sidebar-accent': '46 23% 89%',
          'sidebar-accent-foreground': '120 0% 20%',
          'sidebar-border': '0 0% 92%',
          'sidebar-ring': '180 0% 71%',
          'font-sans':
            "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono':
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '60 3% 15%',
          foreground: '46 10% 74%',
          card: '60 3% 15%',
          'card-foreground': '48 33% 97%',
          popover: '60 2% 18%',
          'popover-foreground': '60 5% 89%',
          primary: '15 63% 60%',
          'primary-foreground': '0 0% 100%',
          secondary: '48 33% 97%',
          'secondary-foreground': '60 2% 18%',
          muted: '60 4% 10%',
          'muted-foreground': '51 9% 69%',
          accent: '48 11% 9%',
          'accent-foreground': '51 26% 95%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '60 5% 23%',
          input: '53 5% 31%',
          ring: '15 63% 60%',
          'chart-1': '18 57% 44%',
          'chart-2': '251 85% 75%',
          'chart-3': '48 11% 9%',
          'chart-4': '248 25% 23%',
          'chart-5': '18 60% 44%',
          radius: '0.5rem',
          sidebar: '30 3% 12%',
          'sidebar-foreground': '46 10% 74%',
          'sidebar-primary': '120 0% 20%',
          'sidebar-primary-foreground': '0 0% 98%',
          'sidebar-accent': '60 3% 6%',
          'sidebar-accent-foreground': '46 10% 74%',
          'sidebar-border': '0 0% 92%',
          'sidebar-ring': '180 0% 71%',
          'font-sans':
            "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
          'font-serif': 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
          'font-mono':
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.1',
          'shadow-blur': '3px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-xs': '0 1px 3px 0px hsl(0 0% 0% / 0.05)',
          'shadow-sm': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          shadow: '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 1px 2px -1px hsl(0 0% 0% / 0.10)',
          'shadow-md': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 2px 4px -1px hsl(0 0% 0% / 0.10)',
          'shadow-lg': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 4px 6px -1px hsl(0 0% 0% / 0.10)',
          'shadow-xl': '0 1px 3px 0px hsl(0 0% 0% / 0.10), 0 8px 10px -1px hsl(0 0% 0% / 0.10)',
          'shadow-2xl': '0 1px 3px 0px hsl(0 0% 0% / 0.25)',
        },
      },
    },
    {
      name: 'vercel',
      type: 'registry:style',
      title: 'Vercel',
      description: 'A theme based on the Vercel color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Geist, sans-serif',
          'font-mono': 'Geist Mono, monospace',
          'font-serif': 'Georgia, serif',
          radius: '0.5rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '120 0% 99%',
          foreground: '0 0% 0%',
          card: '0 0% 100%',
          'card-foreground': '0 0% 0%',
          popover: '120 0% 99%',
          'popover-foreground': '0 0% 0%',
          primary: '0 0% 0%',
          'primary-foreground': '0 0% 100%',
          secondary: '60 0% 92%',
          'secondary-foreground': '0 0% 0%',
          muted: '120 0% 96%',
          'muted-foreground': '300 0% 32%',
          accent: '60 0% 92%',
          'accent-foreground': '0 0% 0%',
          destructive: '358 75% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '150 0% 90%',
          input: '60 0% 92%',
          ring: '0 0% 0%',
          'chart-1': '41 100% 51%',
          'chart-2': '224 86% 56%',
          'chart-3': '120 0% 64%',
          'chart-4': '150 0% 90%',
          'chart-5': '0 0% 46%',
          radius: '0.5rem',
          sidebar: '120 0% 99%',
          'sidebar-foreground': '0 0% 0%',
          'sidebar-primary': '0 0% 0%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '60 0% 92%',
          'sidebar-accent-foreground': '0 0% 0%',
          'sidebar-border': '60 0% 92%',
          'sidebar-ring': '0 0% 0%',
          'font-sans': 'Geist, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': 'Geist Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.18',
          'shadow-blur': '2px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 1px 2px 0px hsl(0 0% 0% / 0.09)',
          'shadow-xs': '0px 1px 2px 0px hsl(0 0% 0% / 0.09)',
          'shadow-sm': '0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 1px 2px -1px hsl(0 0% 0% / 0.18)',
          shadow: '0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 1px 2px -1px hsl(0 0% 0% / 0.18)',
          'shadow-md': '0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 2px 4px -1px hsl(0 0% 0% / 0.18)',
          'shadow-lg': '0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 4px 6px -1px hsl(0 0% 0% / 0.18)',
          'shadow-xl': '0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 8px 10px -1px hsl(0 0% 0% / 0.18)',
          'shadow-2xl': '0px 1px 2px 0px hsl(0 0% 0% / 0.45)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '0 0% 0%',
          foreground: '0 0% 100%',
          card: '0 0% 4%',
          'card-foreground': '0 0% 100%',
          popover: '0 0% 7%',
          'popover-foreground': '0 0% 100%',
          primary: '0 0% 100%',
          'primary-foreground': '0 0% 0%',
          secondary: '0 0% 13%',
          'secondary-foreground': '0 0% 100%',
          muted: '120 0% 11%',
          'muted-foreground': '120 0% 64%',
          accent: '0 0% 20%',
          'accent-foreground': '0 0% 100%',
          destructive: '360 100% 68%',
          'destructive-foreground': '0 0% 0%',
          border: '0 0% 14%',
          input: '0 0% 20%',
          ring: '120 0% 64%',
          'chart-1': '41 100% 51%',
          'chart-2': '218 90% 55%',
          'chart-3': '0 0% 46%',
          'chart-4': '300 0% 32%',
          'chart-5': '150 0% 90%',
          radius: '0.5rem',
          sidebar: '0 0% 7%',
          'sidebar-foreground': '0 0% 100%',
          'sidebar-primary': '0 0% 100%',
          'sidebar-primary-foreground': '0 0% 0%',
          'sidebar-accent': '0 0% 20%',
          'sidebar-accent-foreground': '0 0% 100%',
          'sidebar-border': '0 0% 20%',
          'sidebar-ring': '120 0% 64%',
          'font-sans': 'Geist, sans-serif',
          'font-serif': 'Georgia, serif',
          'font-mono': 'Geist Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.18',
          'shadow-blur': '2px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 1px 2px 0px hsl(0 0% 0% / 0.09)',
          'shadow-xs': '0px 1px 2px 0px hsl(0 0% 0% / 0.09)',
          'shadow-sm': '0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 1px 2px -1px hsl(0 0% 0% / 0.18)',
          shadow: '0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 1px 2px -1px hsl(0 0% 0% / 0.18)',
          'shadow-md': '0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 2px 4px -1px hsl(0 0% 0% / 0.18)',
          'shadow-lg': '0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 4px 6px -1px hsl(0 0% 0% / 0.18)',
          'shadow-xl': '0px 1px 2px 0px hsl(0 0% 0% / 0.18), 0px 8px 10px -1px hsl(0 0% 0% / 0.18)',
          'shadow-2xl': '0px 1px 2px 0px hsl(0 0% 0% / 0.45)',
        },
      },
    },
    {
      name: 'darkmatter',
      type: 'registry:style',
      title: 'Darkmatter',
      description: 'A theme based on the Darkmatter color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Geist Mono, ui-monospace, monospace',
          'font-mono': 'JetBrains Mono, monospace',
          'font-serif': 'serif',
          radius: '0.75rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '0 0% 100%',
          foreground: '221 39% 11%',
          card: '0 0% 100%',
          'card-foreground': '221 39% 11%',
          popover: '0 0% 100%',
          'popover-foreground': '221 39% 11%',
          primary: '22 66% 55%',
          'primary-foreground': '0 0% 100%',
          secondary: '180 18% 39%',
          'secondary-foreground': '0 0% 100%',
          muted: '220 14% 96%',
          'muted-foreground': '220 9% 46%',
          accent: '150 0% 93%',
          'accent-foreground': '221 39% 11%',
          destructive: '0 84% 60%',
          'destructive-foreground': '60 0% 98%',
          border: '220 13% 91%',
          input: '220 13% 91%',
          ring: '22 66% 55%',
          'chart-1': '180 17% 45%',
          'chart-2': '22 76% 62%',
          'chart-3': '31 93% 79%',
          'chart-4': '0 0% 53%',
          'chart-5': '180 0% 60%',
          radius: '0.75rem',
          sidebar: '220 14% 96%',
          'sidebar-foreground': '221 39% 11%',
          'sidebar-primary': '22 66% 55%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '0 0% 100%',
          'sidebar-accent-foreground': '221 39% 11%',
          'sidebar-border': '220 13% 91%',
          'sidebar-ring': '22 66% 55%',
          'font-sans': 'Geist Mono, ui-monospace, monospace',
          'font-serif': 'serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.05',
          'shadow-blur': '4px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0rem',
          spacing: '0.25rem',
          'shadow-2xs': '0px 1px 4px 0px hsl(0 0% 0% / 0.03)',
          'shadow-xs': '0px 1px 4px 0px hsl(0 0% 0% / 0.03)',
          'shadow-sm': '0px 1px 4px 0px hsl(0 0% 0% / 0.05), 0px 1px 2px -1px hsl(0 0% 0% / 0.05)',
          shadow: '0px 1px 4px 0px hsl(0 0% 0% / 0.05), 0px 1px 2px -1px hsl(0 0% 0% / 0.05)',
          'shadow-md': '0px 1px 4px 0px hsl(0 0% 0% / 0.05), 0px 2px 4px -1px hsl(0 0% 0% / 0.05)',
          'shadow-lg': '0px 1px 4px 0px hsl(0 0% 0% / 0.05), 0px 4px 6px -1px hsl(0 0% 0% / 0.05)',
          'shadow-xl': '0px 1px 4px 0px hsl(0 0% 0% / 0.05), 0px 8px 10px -1px hsl(0 0% 0% / 0.05)',
          'shadow-2xl': '0px 1px 4px 0px hsl(0 0% 0% / 0.13)',
          'tracking-normal': '0rem',
        },
        dark: {
          background: '270 6% 7%',
          foreground: '180 0% 76%',
          card: '0 0% 7%',
          'card-foreground': '180 0% 76%',
          popover: '270 6% 7%',
          'popover-foreground': '180 0% 76%',
          primary: '22 76% 62%',
          'primary-foreground': '270 6% 7%',
          secondary: '180 17% 45%',
          'secondary-foreground': '270 6% 7%',
          muted: '300 0% 13%',
          'muted-foreground': '0 0% 53%',
          accent: '0 0% 20%',
          'accent-foreground': '180 0% 76%',
          destructive: '180 17% 45%',
          'destructive-foreground': '270 6% 7%',
          border: '300 0% 13%',
          input: '300 0% 13%',
          ring: '22 76% 62%',
          'chart-1': '180 17% 45%',
          'chart-2': '22 76% 62%',
          'chart-3': '31 93% 79%',
          'chart-4': '0 0% 53%',
          'chart-5': '180 0% 60%',
          radius: '0.75rem',
          sidebar: '0 0% 7%',
          'sidebar-foreground': '180 0% 76%',
          'sidebar-primary': '22 76% 62%',
          'sidebar-primary-foreground': '270 6% 7%',
          'sidebar-accent': '0 0% 20%',
          'sidebar-accent-foreground': '180 0% 76%',
          'sidebar-border': '300 0% 13%',
          'sidebar-ring': '22 76% 62%',
          'font-sans': 'Geist Mono, ui-monospace, monospace',
          'font-serif': 'serif',
          'font-mono': 'JetBrains Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0.05',
          'shadow-blur': '4px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0rem',
          spacing: '0.25rem',
          'shadow-2xs': '0px 1px 4px 0px hsl(0 0% 0% / 0.03)',
          'shadow-xs': '0px 1px 4px 0px hsl(0 0% 0% / 0.03)',
          'shadow-sm': '0px 1px 4px 0px hsl(0 0% 0% / 0.05), 0px 1px 2px -1px hsl(0 0% 0% / 0.05)',
          shadow: '0px 1px 4px 0px hsl(0 0% 0% / 0.05), 0px 1px 2px -1px hsl(0 0% 0% / 0.05)',
          'shadow-md': '0px 1px 4px 0px hsl(0 0% 0% / 0.05), 0px 2px 4px -1px hsl(0 0% 0% / 0.05)',
          'shadow-lg': '0px 1px 4px 0px hsl(0 0% 0% / 0.05), 0px 4px 6px -1px hsl(0 0% 0% / 0.05)',
          'shadow-xl': '0px 1px 4px 0px hsl(0 0% 0% / 0.05), 0px 8px 10px -1px hsl(0 0% 0% / 0.05)',
          'shadow-2xl': '0px 1px 4px 0px hsl(0 0% 0% / 0.13)',
        },
      },
    },
    {
      name: 'mono',
      type: 'registry:style',
      title: 'Mono',
      description: 'A theme based on the Mono color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'Geist Mono, monospace',
          'font-mono': 'Geist Mono, monospace',
          'font-serif': 'Geist Mono, monospace',
          radius: '0rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '0 0% 100%',
          foreground: '180 0% 4%',
          card: '0 0% 100%',
          'card-foreground': '180 0% 4%',
          popover: '0 0% 100%',
          'popover-foreground': '180 0% 4%',
          primary: '0 0% 45%',
          'primary-foreground': '60 0% 98%',
          secondary: '0 0% 96%',
          'secondary-foreground': '180 0% 9%',
          muted: '0 0% 96%',
          'muted-foreground': '180 0% 44%',
          accent: '0 0% 96%',
          'accent-foreground': '180 0% 9%',
          destructive: '357 100% 45%',
          'destructive-foreground': '0 0% 96%',
          border: '120 0% 90%',
          input: '120 0% 90%',
          ring: '0 0% 63%',
          'chart-1': '0 0% 45%',
          'chart-2': '0 0% 45%',
          'chart-3': '0 0% 45%',
          'chart-4': '0 0% 45%',
          'chart-5': '0 0% 45%',
          radius: '0rem',
          sidebar: '60 0% 98%',
          'sidebar-foreground': '180 0% 4%',
          'sidebar-primary': '180 0% 9%',
          'sidebar-primary-foreground': '60 0% 98%',
          'sidebar-accent': '0 0% 96%',
          'sidebar-accent-foreground': '180 0% 9%',
          'sidebar-border': '120 0% 90%',
          'sidebar-ring': '0 0% 63%',
          'font-sans': 'Geist Mono, monospace',
          'font-serif': 'Geist Mono, monospace',
          'font-mono': 'Geist Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 1px 0px 0px hsl(0 0% 0% / 0.00)',
          'shadow-xs': '0px 1px 0px 0px hsl(0 0% 0% / 0.00)',
          'shadow-sm': '0px 1px 0px 0px hsl(0 0% 0% / 0.00), 0px 1px 2px -1px hsl(0 0% 0% / 0.00)',
          shadow: '0px 1px 0px 0px hsl(0 0% 0% / 0.00), 0px 1px 2px -1px hsl(0 0% 0% / 0.00)',
          'shadow-md': '0px 1px 0px 0px hsl(0 0% 0% / 0.00), 0px 2px 4px -1px hsl(0 0% 0% / 0.00)',
          'shadow-lg': '0px 1px 0px 0px hsl(0 0% 0% / 0.00), 0px 4px 6px -1px hsl(0 0% 0% / 0.00)',
          'shadow-xl': '0px 1px 0px 0px hsl(0 0% 0% / 0.00), 0px 8px 10px -1px hsl(0 0% 0% / 0.00)',
          'shadow-2xl': '0px 1px 0px 0px hsl(0 0% 0% / 0.00)',
          'tracking-normal': '0em',
        },
        dark: {
          background: '180 0% 4%',
          foreground: '60 0% 98%',
          card: '0 0% 10%',
          'card-foreground': '60 0% 98%',
          popover: '0 0% 15%',
          'popover-foreground': '60 0% 98%',
          primary: '0 0% 45%',
          'primary-foreground': '60 0% 98%',
          secondary: '0 0% 15%',
          'secondary-foreground': '60 0% 98%',
          muted: '0 0% 15%',
          'muted-foreground': '0 0% 63%',
          accent: '0 0% 25%',
          'accent-foreground': '60 0% 98%',
          destructive: '359 100% 70%',
          'destructive-foreground': '0 0% 15%',
          border: '0 0% 22%',
          input: '300 0% 32%',
          ring: '0 0% 45%',
          'chart-1': '0 0% 45%',
          'chart-2': '0 0% 45%',
          'chart-3': '0 0% 45%',
          'chart-4': '0 0% 45%',
          'chart-5': '0 0% 45%',
          radius: '0rem',
          sidebar: '180 0% 9%',
          'sidebar-foreground': '60 0% 98%',
          'sidebar-primary': '60 0% 98%',
          'sidebar-primary-foreground': '180 0% 9%',
          'sidebar-accent': '0 0% 15%',
          'sidebar-accent-foreground': '60 0% 98%',
          'sidebar-border': '0 0% 100%',
          'sidebar-ring': '300 0% 32%',
          'font-sans': 'Geist Mono, monospace',
          'font-serif': 'Geist Mono, monospace',
          'font-mono': 'Geist Mono, monospace',
          'shadow-color': '0 0% 0%',
          'shadow-opacity': '0',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '1px',
          'letter-spacing': '0em',
          spacing: '0.25rem',
          'shadow-2xs': '0px 1px 0px 0px hsl(0 0% 0% / 0.00)',
          'shadow-xs': '0px 1px 0px 0px hsl(0 0% 0% / 0.00)',
          'shadow-sm': '0px 1px 0px 0px hsl(0 0% 0% / 0.00), 0px 1px 2px -1px hsl(0 0% 0% / 0.00)',
          shadow: '0px 1px 0px 0px hsl(0 0% 0% / 0.00), 0px 1px 2px -1px hsl(0 0% 0% / 0.00)',
          'shadow-md': '0px 1px 0px 0px hsl(0 0% 0% / 0.00), 0px 2px 4px -1px hsl(0 0% 0% / 0.00)',
          'shadow-lg': '0px 1px 0px 0px hsl(0 0% 0% / 0.00), 0px 4px 6px -1px hsl(0 0% 0% / 0.00)',
          'shadow-xl': '0px 1px 0px 0px hsl(0 0% 0% / 0.00), 0px 8px 10px -1px hsl(0 0% 0% / 0.00)',
          'shadow-2xl': '0px 1px 0px 0px hsl(0 0% 0% / 0.00)',
        },
      },
    },
    {
      name: 'soft-pop',
      type: 'registry:style',
      title: 'Soft Pop',
      description: 'A theme based on the Soft Pop color palette.',
      css: {
        '@layer base': {
          body: {
            'letter-spacing': 'var(--tracking-normal)',
          },
        },
      },
      cssVars: {
        theme: {
          'font-sans': 'DM Sans, sans-serif',
          'font-mono': 'Space Mono, monospace',
          'font-serif': 'DM Sans, sans-serif',
          radius: '1rem',
          'tracking-tighter': 'calc(var(--tracking-normal) - 0.05em)',
          'tracking-tight': 'calc(var(--tracking-normal) - 0.025em)',
          'tracking-wide': 'calc(var(--tracking-normal) + 0.025em)',
          'tracking-wider': 'calc(var(--tracking-normal) + 0.05em)',
          'tracking-widest': 'calc(var(--tracking-normal) + 0.1em)',
        },
        light: {
          background: '80 33% 96%',
          foreground: '0 0% 0%',
          card: '0 0% 100%',
          'card-foreground': '0 0% 0%',
          popover: '0 0% 100%',
          'popover-foreground': '0 0% 0%',
          primary: '243 75% 59%',
          'primary-foreground': '0 0% 100%',
          secondary: '173 80% 40%',
          'secondary-foreground': '0 0% 100%',
          muted: '240 0% 94%',
          'muted-foreground': '0 0% 20%',
          accent: '38 92% 50%',
          'accent-foreground': '0 0% 0%',
          destructive: '0 84% 60%',
          'destructive-foreground': '0 0% 100%',
          border: '0 0% 0%',
          input: '0 0% 45%',
          ring: '230 94% 82%',
          'chart-1': '243 75% 59%',
          'chart-2': '173 80% 40%',
          'chart-3': '38 92% 50%',
          'chart-4': '330 81% 60%',
          'chart-5': '142 71% 45%',
          radius: '1rem',
          sidebar: '80 33% 96%',
          'sidebar-foreground': '0 0% 0%',
          'sidebar-primary': '243 75% 59%',
          'sidebar-primary-foreground': '0 0% 100%',
          'sidebar-accent': '38 92% 50%',
          'sidebar-accent-foreground': '0 0% 0%',
          'sidebar-border': '0 0% 0%',
          'sidebar-ring': '230 94% 82%',
          'font-sans': 'DM Sans, sans-serif',
          'font-serif': 'DM Sans, sans-serif',
          'font-mono': 'Space Mono, monospace',
          'shadow-color': '0 0% 10%',
          'shadow-opacity': '0.05',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '0px',
          'letter-spacing': 'normal',
          spacing: '0.25rem',
          'shadow-2xs': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.03)',
          'shadow-xs': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.03)',
          'shadow-sm': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.05), 0px 1px 2px -1px hsl(0 0% 10.1961% / 0.05)',
          shadow: '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.05), 0px 1px 2px -1px hsl(0 0% 10.1961% / 0.05)',
          'shadow-md': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.05), 0px 2px 4px -1px hsl(0 0% 10.1961% / 0.05)',
          'shadow-lg': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.05), 0px 4px 6px -1px hsl(0 0% 10.1961% / 0.05)',
          'shadow-xl': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.05), 0px 8px 10px -1px hsl(0 0% 10.1961% / 0.05)',
          'shadow-2xl': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.13)',
          'tracking-normal': 'normal',
        },
        dark: {
          background: '0 0% 0%',
          foreground: '0 0% 100%',
          card: '215 25% 14%',
          'card-foreground': '0 0% 100%',
          popover: '215 25% 14%',
          'popover-foreground': '0 0% 100%',
          primary: '234 89% 74%',
          'primary-foreground': '0 0% 0%',
          secondary: '172 66% 50%',
          'secondary-foreground': '0 0% 0%',
          muted: '0 0% 20%',
          'muted-foreground': '180 0% 80%',
          accent: '46 97% 65%',
          'accent-foreground': '0 0% 0%',
          destructive: '0 91% 71%',
          'destructive-foreground': '0 0% 0%',
          border: '0 0% 33%',
          input: '0 0% 100%',
          ring: '234 89% 74%',
          'chart-1': '234 89% 74%',
          'chart-2': '172 66% 50%',
          'chart-3': '46 97% 65%',
          'chart-4': '329 86% 70%',
          'chart-5': '142 69% 58%',
          radius: '1rem',
          sidebar: '0 0% 0%',
          'sidebar-foreground': '0 0% 100%',
          'sidebar-primary': '234 89% 74%',
          'sidebar-primary-foreground': '0 0% 0%',
          'sidebar-accent': '46 97% 65%',
          'sidebar-accent-foreground': '0 0% 0%',
          'sidebar-border': '0 0% 100%',
          'sidebar-ring': '234 89% 74%',
          'font-sans': 'DM Sans, sans-serif',
          'font-serif': 'DM Sans, sans-serif',
          'font-mono': 'Space Mono, monospace',
          'shadow-color': '0 0% 10%',
          'shadow-opacity': '0.05',
          'shadow-blur': '0px',
          'shadow-spread': '0px',
          'shadow-offset-x': '0px',
          'shadow-offset-y': '0px',
          'letter-spacing': 'normal',
          spacing: '0.25rem',
          'shadow-2xs': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.03)',
          'shadow-xs': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.03)',
          'shadow-sm': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.05), 0px 1px 2px -1px hsl(0 0% 10.1961% / 0.05)',
          shadow: '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.05), 0px 1px 2px -1px hsl(0 0% 10.1961% / 0.05)',
          'shadow-md': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.05), 0px 2px 4px -1px hsl(0 0% 10.1961% / 0.05)',
          'shadow-lg': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.05), 0px 4px 6px -1px hsl(0 0% 10.1961% / 0.05)',
          'shadow-xl': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.05), 0px 8px 10px -1px hsl(0 0% 10.1961% / 0.05)',
          'shadow-2xl': '0px 0px 0px 0px hsl(0 0% 10.1961% / 0.13)',
        },
      },
    },
  ],
} as const;

export default tweakcnThemeRegistry;
